import clsx from "clsx";
// import { roadmap } from '../../../../data'
import styles from "./Roadmap.module.scss";
import { Partnerships, alphaPhase, betaPhase } from "../../../../data";
import Footer from "../../../Footer/Footer";
import { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import FlashingStars from "../../../../shared/FlashingStars/FlashingStars";
import { IPhase, IRoadmap } from "../../../../interfaces/IData";
import { roadmapService } from "../../../../app/services/Roadmap.service";
import { getMediaUrl } from "../../../../utils";

const MAX_DEGREE = 0;
const MAX_OFFSET_X = 10;
const MAX_OFFSET_Y = 10;

export const Roadmap = () => {
  /* const [roadmap, setRoadmap] = useState<IRoadmap[]>(); */

  const roadmap = [
    {
      id: 1,
      title: "Launch Phase",
      phases: [
        {
          id: 1,
          name: "Website Release",
          icon: {
            id: 10,
            name: "4.svg",
            alternativeText: null,
            caption: null,
            width: 18,
            height: 19,
            formats: null,
            hash: "4_fdffb6bc49",
            ext: ".svg",
            mime: "image/svg+xml",
            size: 6.92,
            url: "/images/Roadmap/1.svg",
            previewUrl: null,
            provider: "local",
            provider_metadata: null,
            folderPath: "/",
            createdAt: "2023-08-15T12:24:54.544Z",
            updatedAt: "2023-08-15T12:24:54.544Z",
          },
        },
        {
          id: 2,
          name: "Gitbook Documentation",
          icon: {
            id: 13,
            name: "8.svg",
            alternativeText: null,
            caption: null,
            width: 18,
            height: 19,
            formats: null,
            hash: "8_e637c5ce4f",
            ext: ".svg",
            mime: "image/svg+xml",
            size: 7.58,
            url: "/images/Roadmap/1.svg",
            previewUrl: null,
            provider: "local",
            provider_metadata: null,
            folderPath: "/",
            createdAt: "2023-08-15T12:24:54.698Z",
            updatedAt: "2023-08-15T12:24:54.698Z",
          },
        },
        {
          id: 3,
          name: "$PROPHET Launch",
          icon: {
            id: 18,
            name: "rocket-white.svg",
            alternativeText: null,
            caption: null,
            width: 18,
            height: 19,
            formats: null,
            hash: "rocket_white_847d775774",
            ext: ".svg",
            mime: "image/svg+xml",
            size: 5.15,
            url: "/images/Roadmap/1.svg",
            previewUrl: null,
            provider: "local",
            provider_metadata: null,
            folderPath: "/",
            createdAt: "2023-08-15T12:26:42.828Z",
            updatedAt: "2023-08-15T12:26:42.828Z",
          },
        },
        {
          id: 4,
          name: "Manual Token Sniper",
          icon: {
            id: 8,
            name: "5.svg",
            alternativeText: null,
            caption: null,
            width: 18,
            height: 18,
            formats: null,
            hash: "5_ffd268ce0d",
            ext: ".svg",
            mime: "image/svg+xml",
            size: 2.24,
            url: "/images/Roadmap/1.svg",
            previewUrl: null,
            provider: "local",
            provider_metadata: null,
            folderPath: "/",
            createdAt: "2023-08-15T12:24:54.542Z",
            updatedAt: "2023-08-15T12:30:25.616Z",
          },
        },
        {
          id: 5,
          name: "AutoSniper",
          icon: {
            id: 7,
            name: "3.svg",
            alternativeText: null,
            caption: null,
            width: 18,
            height: 18,
            formats: null,
            hash: "3_e331b73766",
            ext: ".svg",
            mime: "image/svg+xml",
            size: 4.96,
            url: "/images/Roadmap/1.svg",
            previewUrl: null,
            provider: "local",
            provider_metadata: null,
            folderPath: "/",
            createdAt: "2023-08-15T12:24:54.425Z",
            updatedAt: "2023-08-15T12:28:53.758Z",
          },
        },
        {
          id: 6,
          name: "Multi-Wallet Generation & System",
          icon: {
            id: 12,
            name: "9.svg",
            alternativeText: null,
            caption: null,
            width: 18,
            height: 19,
            formats: null,
            hash: "9_ba77da915e",
            ext: ".svg",
            mime: "image/svg+xml",
            size: 3.42,
            url: "/images/Roadmap/1.svg",
            previewUrl: null,
            provider: "local",
            provider_metadata: null,
            folderPath: "/",
            createdAt: "2023-08-15T12:24:54.697Z",
            updatedAt: "2023-08-15T12:30:45.667Z",
          },
        },
        {
          id: 7,
          name: "P&L Analytical Image Generation",
          icon: {
            id: 15,
            name: "10.svg",
            alternativeText: null,
            caption: null,
            width: 18,
            height: 18,
            formats: null,
            hash: "10_cee9753a2d",
            ext: ".svg",
            mime: "image/svg+xml",
            size: 4.05,
            url: "/images/Roadmap/1.svg",
            previewUrl: null,
            provider: "local",
            provider_metadata: null,
            folderPath: "/",
            createdAt: "2023-08-15T12:24:54.722Z",
            updatedAt: "2023-08-15T12:27:32.417Z",
          },
        },
        {
          id: 8,
          name: "ProphetBots Perfected Signal Algorithms ",
          icon: {
            id: 11,
            name: "7.svg",
            alternativeText: null,
            caption: null,
            width: 18,
            height: 19,
            formats: null,
            hash: "7_ac0e524a46",
            ext: ".svg",
            mime: "image/svg+xml",
            size: 3.29,
            url: "/images/Roadmap/1.svg",
            previewUrl: null,
            provider: "local",
            provider_metadata: null,
            folderPath: "/",
            createdAt: "2023-08-15T12:24:54.695Z",
            updatedAt: "2023-08-15T12:24:54.695Z",
          },
        },
        {
          id: 9,
          name: "Revenue Sharing",
          icon: {
            id: 9,
            name: "6.svg",
            alternativeText: null,
            caption: null,
            width: 18,
            height: 18,
            formats: null,
            hash: "6_b25ced995d",
            ext: ".svg",
            mime: "image/svg+xml",
            size: 5.85,
            url: "/images/Roadmap/1.svg",
            previewUrl: null,
            provider: "local",
            provider_metadata: null,
            folderPath: "/",
            createdAt: "2023-08-15T12:24:54.543Z",
            updatedAt: "2023-08-15T12:29:26.801Z",
          },
        },
        {
          id: 10,
          name: "Copytrader",
          icon: {
            id: 14,
            name: "11.svg",
            alternativeText: null,
            caption: null,
            width: 18,
            height: 19,
            formats: null,
            hash: "11_325fa80bdf",
            ext: ".svg",
            mime: "image/svg+xml",
            size: 4.06,
            url: "/images/Roadmap/1.svg",
            previewUrl: null,
            provider: "local",
            provider_metadata: null,
            folderPath: "/",
            createdAt: "2023-08-15T12:24:54.718Z",
            updatedAt: "2023-08-15T12:24:54.718Z",
          },
        },
      ],
    },
    {
      id: 2,
      title: "Prophecy Phase",
      phases: [
        {
          id: 11,
          name: "Interactive Revenue Sharing Dashboard",
          icon: {
            id: 5,
            name: "1.svg",
            alternativeText: null,
            caption: null,
            width: 18,
            height: 19,
            formats: null,
            hash: "1_4f9bd02110",
            ext: ".svg",
            mime: "image/svg+xml",
            size: 1.51,
            url: "/images/Roadmap/1.svg",
            previewUrl: null,
            provider: "local",
            provider_metadata: null,
            folderPath: "/",
            createdAt: "2023-08-15T12:24:54.423Z",
            updatedAt: "2023-08-15T12:30:09.511Z",
          },
        },
        {
          id: 12,
          name: "Referral System",
          icon: {
            id: 12,
            name: "9.svg",
            alternativeText: null,
            caption: null,
            width: 18,
            height: 19,
            formats: null,
            hash: "9_ba77da915e",
            ext: ".svg",
            mime: "image/svg+xml",
            size: 3.42,
            url: "/images/Roadmap/1.svg",
            previewUrl: null,
            provider: "local",
            provider_metadata: null,
            folderPath: "/",
            createdAt: "2023-08-15T12:24:54.697Z",
            updatedAt: "2023-08-15T12:30:45.667Z",
          },
        },
        {
          id: 13,
          name: "Signal Ratings",
          icon: {
            id: 7,
            name: "3.svg",
            alternativeText: null,
            caption: null,
            width: 18,
            height: 18,
            formats: null,
            hash: "3_e331b73766",
            ext: ".svg",
            mime: "image/svg+xml",
            size: 4.96,
            url: "/images/Roadmap/1.svg",
            previewUrl: null,
            provider: "local",
            provider_metadata: null,
            folderPath: "/",
            createdAt: "2023-08-15T12:24:54.425Z",
            updatedAt: "2023-08-15T12:28:53.758Z",
          },
        },
        {
          id: 14,
          name: "Extreme Machine Learnt AutoSniper",
          icon: {
            id: 10,
            name: "4.svg",
            alternativeText: null,
            caption: null,
            width: 18,
            height: 19,
            formats: null,
            hash: "4_fdffb6bc49",
            ext: ".svg",
            mime: "image/svg+xml",
            size: 6.92,
            url: "/images/Roadmap/1.svg",
            previewUrl: null,
            provider: "local",
            provider_metadata: null,
            folderPath: "/",
            createdAt: "2023-08-15T12:24:54.544Z",
            updatedAt: "2023-08-15T12:24:54.544Z",
          },
        },
        {
          id: 15,
          name: "Algorithm Backtesting Improvements ",
          icon: {
            id: 8,
            name: "5.svg",
            alternativeText: null,
            caption: null,
            width: 18,
            height: 18,
            formats: null,
            hash: "5_ffd268ce0d",
            ext: ".svg",
            mime: "image/svg+xml",
            size: 2.24,
            url: "/images/Roadmap/1.svg",
            previewUrl: null,
            provider: "local",
            provider_metadata: null,
            folderPath: "/",
            createdAt: "2023-08-15T12:24:54.542Z",
            updatedAt: "2023-08-15T12:30:25.616Z",
          },
        },
        {
          id: 16,
          name: "Presale Sniper",
          icon: {
            id: 9,
            name: "6.svg",
            alternativeText: null,
            caption: null,
            width: 18,
            height: 18,
            formats: null,
            hash: "6_b25ced995d",
            ext: ".svg",
            mime: "image/svg+xml",
            size: 5.85,
            url: "/images/Roadmap/1.svg",
            previewUrl: null,
            provider: "local",
            provider_metadata: null,
            folderPath: "/",
            createdAt: "2023-08-15T12:24:54.543Z",
            updatedAt: "2023-08-15T12:29:26.801Z",
          },
        },
        {
          id: 17,
          name: "Strategic Partnerships",
          icon: {
            id: 11,
            name: "7.svg",
            alternativeText: null,
            caption: null,
            width: 18,
            height: 19,
            formats: null,
            hash: "7_ac0e524a46",
            ext: ".svg",
            mime: "image/svg+xml",
            size: 3.29,
            url: "/images/Roadmap/1.svg",
            previewUrl: null,
            provider: "local",
            provider_metadata: null,
            folderPath: "/",
            createdAt: "2023-08-15T12:24:54.695Z",
            updatedAt: "2023-08-15T12:24:54.695Z",
          },
        },
        {
          id: 27,
          name: "Limit Orders",
          icon: {
            id: 15,
            name: "10.svg",
            alternativeText: null,
            caption: null,
            width: 18,
            height: 18,
            formats: null,
            hash: "10_cee9753a2d",
            ext: ".svg",
            mime: "image/svg+xml",
            size: 4.05,
            url: "/images/Roadmap/1.svg",
            previewUrl: null,
            provider: "local",
            provider_metadata: null,
            folderPath: "/",
            createdAt: "2023-08-15T12:24:54.722Z",
            updatedAt: "2023-08-15T12:27:32.417Z",
          },
        },
      ],
    },
    {
      id: 3,
      title: "Moon Phase",
      phases: [
        {
          id: 18,
          name: "Additional Profit Driven User Rewards",
          icon: {
            id: 10,
            name: "4.svg",
            alternativeText: null,
            caption: null,
            width: 18,
            height: 19,
            formats: null,
            hash: "4_fdffb6bc49",
            ext: ".svg",
            mime: "image/svg+xml",
            size: 6.92,
            url: "/images/Roadmap/1.svg",
            previewUrl: null,
            provider: "local",
            provider_metadata: null,
            folderPath: "/",
            createdAt: "2023-08-15T12:24:54.544Z",
            updatedAt: "2023-08-15T12:24:54.544Z",
          },
        },
        {
          id: 19,
          name: "ProphetBot 2.0",
          icon: {
            id: 5,
            name: "1.svg",
            alternativeText: null,
            caption: null,
            width: 18,
            height: 19,
            formats: null,
            hash: "1_4f9bd02110",
            ext: ".svg",
            mime: "image/svg+xml",
            size: 1.51,
            url: "/images/Roadmap/1.svg",
            previewUrl: null,
            provider: "local",
            provider_metadata: null,
            folderPath: "/",
            createdAt: "2023-08-15T12:24:54.423Z",
            updatedAt: "2023-08-15T12:30:09.511Z",
          },
        },
        {
          id: 20,
          name: "Moonshot Mode",
          icon: {
            id: 8,
            name: "5.svg",
            alternativeText: null,
            caption: null,
            width: 18,
            height: 18,
            formats: null,
            hash: "5_ffd268ce0d",
            ext: ".svg",
            mime: "image/svg+xml",
            size: 2.24,
            url: "/images/Roadmap/1.svg",
            previewUrl: null,
            provider: "local",
            provider_metadata: null,
            folderPath: "/",
            createdAt: "2023-08-15T12:24:54.542Z",
            updatedAt: "2023-08-15T12:30:25.616Z",
          },
        },
        {
          id: 21,
          name: "Automatic Burn Integration",
          icon: {
            id: 7,
            name: "3.svg",
            alternativeText: null,
            caption: null,
            width: 18,
            height: 18,
            formats: null,
            hash: "3_e331b73766",
            ext: ".svg",
            mime: "image/svg+xml",
            size: 4.96,
            url: "/images/Roadmap/1.svg",
            previewUrl: null,
            provider: "local",
            provider_metadata: null,
            folderPath: "/",
            createdAt: "2023-08-15T12:24:54.425Z",
            updatedAt: "2023-08-15T12:28:53.758Z",
          },
        },
        {
          id: 22,
          name: "Multi-Chain",
          icon: {
            id: 12,
            name: "9.svg",
            alternativeText: null,
            caption: null,
            width: 18,
            height: 19,
            formats: null,
            hash: "9_ba77da915e",
            ext: ".svg",
            mime: "image/svg+xml",
            size: 3.42,
            url: "/images/Roadmap/1.svg",
            previewUrl: null,
            provider: "local",
            provider_metadata: null,
            folderPath: "/",
            createdAt: "2023-08-15T12:24:54.697Z",
            updatedAt: "2023-08-15T12:30:45.667Z",
          },
        },
      ],
    },
  ];

  const transformed = useRef(false);
  const refStars = useRef<HTMLDivElement>(null);

  /* useEffect(() => {
    async function fetchData() {
      const response = await roadmapService.getAll();

      if (response) {
        setRoadmap(response[0].roadmap);
      }
    }

    fetchData();
  }, []); */

  const mouseMove = (ev: React.MouseEvent<HTMLDivElement>) => {
    const transform = (x: number, y: number, degrees: number) => {
      if (!refStars.current) {
        return;
      }

      refStars.current.style.transform = `translate(${x}px, ${y}px) rotate(${degrees}deg)`;
    };

    const target = ev.currentTarget as HTMLDivElement;

    const center = { x: target.offsetWidth / 2, y: target.offsetHeight / 2 };
    const point = { x: ev.clientX, y: ev.clientY };
    const xPoint = point.x - center.x;
    const yPoint = point.y - center.y;
    const x = (xPoint / center.x) * MAX_OFFSET_X;
    const y = (yPoint / center.y) * MAX_OFFSET_Y;
    const angle = ((-xPoint + yPoint * 2) / (center.x + center.y)) * MAX_DEGREE;

    transform(x, y, angle);
    transformed.current = true;
  };

  return (
    <section id='roadmap' className={clsx("section", styles.roadmap, "reveal")}>
      <div onMouseMove={(ev) => mouseMove(ev)} className='container'>
        <div className={styles.wrapper}>
          <h2 className='reveal'>Roadmap</h2>
          {window.innerWidth <= 768 ? (
            <div className={styles.cards}>
              <Swiper spaceBetween={15} slidesPerView={"auto"} speed={750}>
                {roadmap &&
                  roadmap.map((phase: any) => (
                    <SwiperSlide>
                      <div className={styles.cardWrap}>
                        <div className={clsx(styles.block, "reveal")}>
                          <div className={styles.head}>
                            <h5>{phase.title}</h5>
                          </div>
                          <div className={styles.body}>
                            <ul>
                              {phase.phases.map((item: any, idx: number) => (
                                <li key={item.id}>
                                  <img
                                    src={item.icon.url}
                                    alt=''
                                    className={styles.icon}
                                  />
                                  {item.name}
                                </li>
                              ))}
                            </ul>
                          </div>
                          <div
                            className={clsx(styles.layer, styles.layerOne)}
                          ></div>
                          <div
                            className={clsx(styles.layer, styles.layerTwo)}
                          ></div>
                          <div
                            className={clsx(styles.layer, styles.layerThree)}
                          ></div>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
              </Swiper>
            </div>
          ) : (
            <div className={clsx(styles.cards, styles.desktopCards)}>
              {roadmap &&
                roadmap.map((phase: any) => (
                  <div className={styles.cardWrap}>
                    <div
                      className={clsx(styles.block, styles.blured, "reveal")}
                    >
                      <div className={styles.head}>
                        <h5>{phase.title}</h5>
                      </div>
                      <div className={styles.body}>
                        <ul>
                          {phase.phases.map((item: any, idx: number) => {
                            return (
                              <li key={item.id}>
                                <img
                                  src={item.icon.url}
                                  alt=''
                                  className={styles.icon}
                                />
                                {item.name}
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                      <div
                        className={clsx(styles.layer, styles.layerOne)}
                      ></div>
                      <div
                        className={clsx(styles.layer, styles.layerTwo)}
                      ></div>
                      <div
                        className={clsx(styles.layer, styles.layerThree)}
                      ></div>
                    </div>
                  </div>
                ))}
            </div>
          )}
        </div>
        <div ref={refStars} className={styles.starsWrap}>
          <div className={styles.stars}>
            <FlashingStars withAnim={false} />
          </div>
        </div>
        <div className={styles.grid}>
          {window.innerWidth > 768 && (
            <>
              <div className={styles.polygon}>
                <div className={styles.topGradient}></div>
                <div className={styles.gradientBig}></div>

                <svg
                  width={window.innerWidth >= 1920 ? `1920` : window.innerWidth}
                  height={
                    window.innerHeight >= 1080 ? `1080` : window.innerHeight
                  }
                  viewBox={`0 0 ${
                    window.innerWidth >= 1920 ? `1920` : window.innerWidth
                  } ${
                    window.innerHeight >= 1080 ? `1080` : window.innerHeight
                  }`}
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <g clip-path='url(#clip0_336_819)'>
                    <g clip-path='url(#clip1_336_819)'>
                      <g clip-path='url(#clip2_336_819)'>
                        <rect
                          x='1'
                          y='1'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='171'
                          y='1'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='341'
                          y='1'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='511'
                          y='1'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='681'
                          y='1'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='851'
                          y='1'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='1021'
                          y='1'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='1191'
                          y='1'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='1361'
                          y='1'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='1531'
                          y='1'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='1701'
                          y='1'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='1871'
                          y='1'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='2041'
                          y='1'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                      </g>
                      <g clip-path='url(#clip3_336_819)'>
                        <rect
                          x='1'
                          y='191'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='171'
                          y='191'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='341'
                          y='191'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='511'
                          y='191'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='681'
                          y='191'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='851'
                          y='191'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='1021'
                          y='191'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='1191'
                          y='191'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='1361'
                          y='191'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='1531'
                          y='191'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='1701'
                          y='191'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='1871'
                          y='191'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='2041'
                          y='191'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                      </g>
                      <g clip-path='url(#clip4_336_819)'>
                        <rect
                          x='1'
                          y='381'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='171'
                          y='381'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='341'
                          y='381'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='511'
                          y='381'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='681'
                          y='381'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='851'
                          y='381'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='1021'
                          y='381'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='1191'
                          y='381'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='1361'
                          y='381'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='1531'
                          y='381'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='1701'
                          y='381'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='1871'
                          y='381'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='2041'
                          y='381'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                      </g>
                      <g clip-path='url(#clip5_336_819)'>
                        <rect
                          x='1'
                          y='571'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='171'
                          y='571'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='341'
                          y='571'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='511'
                          y='571'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='681'
                          y='571'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='851'
                          y='571'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='1021'
                          y='571'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='1191'
                          y='571'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='1361'
                          y='571'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='1531'
                          y='571'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='1701'
                          y='571'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='1871'
                          y='571'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='2041'
                          y='571'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                      </g>
                      <g clip-path='url(#clip6_336_819)'>
                        <rect
                          x='1'
                          y='761'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='171'
                          y='761'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='341'
                          y='761'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='511'
                          y='761'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='681'
                          y='761'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='851'
                          y='761'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='1021'
                          y='761'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='1191'
                          y='761'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='1361'
                          y='761'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='1531'
                          y='761'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='1701'
                          y='761'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='1871'
                          y='761'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='2041'
                          y='761'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                      </g>
                      <g clip-path='url(#clip7_336_819)'>
                        <rect
                          x='1'
                          y='951'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='171'
                          y='951'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='341'
                          y='951'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='511'
                          y='951'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='681'
                          y='951'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='851'
                          y='951'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='1021'
                          y='951'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='1191'
                          y='951'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='1361'
                          y='951'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='1531'
                          y='951'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='1701'
                          y='951'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='1871'
                          y='951'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                        <rect
                          x='2041'
                          y='951'
                          width='168'
                          height='188'
                          stroke='#6E6EFF'
                          stroke-width='2'
                        />
                      </g>
                    </g>
                    <path
                      d='M219 572H338.5V380H456.5'
                      stroke='url(#paint0_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M35 950H170V760.5H271'
                      stroke='url(#paint1_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M400.5 951.5H511V761.5H606'
                      stroke='url(#paint2_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M35 383H169V190.5H261'
                      stroke='url(#paint3_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M745 761H849.5V570H955'
                      stroke='url(#paint4_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M575 1141H679.5V951H785'
                      stroke='url(#paint5_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M745 1140H849.5V950H955'
                      stroke='url(#paint6_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M915 1140H1019.5V950H1125'
                      stroke='url(#paint7_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1085 1140H1189.5V950H1295'
                      stroke='url(#paint8_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1255 1140H1359.5V950H1465'
                      stroke='url(#paint9_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1425 1140H1529.5V950H1635'
                      stroke='url(#paint10_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1595 1140H1699.5V950H1805'
                      stroke='url(#paint11_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1765 1140H1869.5V950H1975'
                      stroke='url(#paint12_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1085 951H1189.5V761H1295'
                      stroke='url(#paint13_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1935 1140H2039.5V950H2145'
                      stroke='url(#paint14_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1255 950H1359.5V760H1465'
                      stroke='url(#paint15_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1425 950H1529.5V760H1635'
                      stroke='url(#paint16_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1765 950H1869.5V760H1975'
                      stroke='url(#paint17_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1595 950H1699.5V760H1805'
                      stroke='url(#paint18_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1255 761H1359.5V571H1465'
                      stroke='url(#paint19_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1425 761H1529.5V571H1635'
                      stroke='url(#paint20_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1595 760H1699.5V570H1805'
                      stroke='url(#paint21_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1765 760H1869.5V570H1975'
                      stroke='url(#paint22_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1935 760H2039.5V570H2145'
                      stroke='url(#paint23_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1255 571H1359.5V381H1465'
                      stroke='url(#paint24_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1425 571H1529.5V381H1635'
                      stroke='url(#paint25_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1595 570H1699.5V380H1805'
                      stroke='url(#paint26_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1765 570H1869.5V380H1975'
                      stroke='url(#paint27_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1935 570H2039.5V380H2145'
                      stroke='url(#paint28_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1255 380H1359.5V190H1465'
                      stroke='url(#paint29_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1425 380H1529.5V190H1635'
                      stroke='url(#paint30_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1595 379H1699.5V189H1805'
                      stroke='url(#paint31_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1425 379H1529.5V189H1635'
                      stroke='url(#paint32_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1595 379H1699.5V189H1805'
                      stroke='url(#paint33_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1765 380H1869.5V190H1975'
                      stroke='url(#paint34_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1935 379H2039.5V189H2145'
                      stroke='url(#paint35_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1255 193H1359.5V3H1465'
                      stroke='url(#paint36_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1255 193H1359.5V3H1465'
                      stroke='url(#paint37_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1765 190H1869.5V0H1975'
                      stroke='url(#paint38_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1935 190H2039.5V0H2145'
                      stroke='url(#paint39_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1595 193H1699.5V3H1805'
                      stroke='url(#paint40_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1425 190H1529.5V0H1635'
                      stroke='url(#paint41_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1425 190H1529.5V0H1635'
                      stroke='url(#paint42_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1085 190H1189.5V0H1295'
                      stroke='url(#paint43_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M915 190H1019.5V0H1125'
                      stroke='url(#paint44_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M745 189H849.5V-1H955'
                      stroke='url(#paint45_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M575 190H679.5V0H785'
                      stroke='url(#paint46_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M405 190H509.5V0H615'
                      stroke='url(#paint47_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M233 190H337.5V0H443'
                      stroke='url(#paint48_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M65 571H169.5V381H275'
                      stroke='url(#paint49_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M65 760H169.5V570H275'
                      stroke='url(#paint50_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M65 190H169.5V0H275'
                      stroke='url(#paint51_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M235 761H339.5V570H445'
                      stroke='url(#paint52_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M235 1141H339.5V950H445'
                      stroke='url(#paint53_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M405 1142H509.5V951H615'
                      stroke='url(#paint54_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M405 570H509.5V379H615'
                      stroke='url(#paint55_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M405 761H509.5V570H615'
                      stroke='url(#paint56_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M405 380H509.5V189H615'
                      stroke='url(#paint57_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M745 381H849.5V190H955'
                      stroke='url(#paint58_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M745 950H849.5V759H955'
                      stroke='url(#paint59_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M915 950H1019.5V759H1125'
                      stroke='url(#paint60_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1085 761H1189.5V570H1295'
                      stroke='url(#paint61_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M915 759H1019.5V568H1125'
                      stroke='url(#paint62_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M915 571H1019.5V380H1125'
                      stroke='url(#paint63_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1085 571H1189.5V380H1295'
                      stroke='url(#paint64_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1085 381H1189.5V190H1295'
                      stroke='url(#paint65_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M575 950H679.5V759H785'
                      stroke='url(#paint66_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M575 572H679.5V381H785'
                      stroke='url(#paint67_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M575 763H679.5V572H785'
                      stroke='url(#paint68_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M915 380H1019.5V189H1125'
                      stroke='url(#paint69_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M66 1140H170.5V949H276'
                      stroke='url(#paint70_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M237 951H341.5V760H447'
                      stroke='url(#paint71_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M1935 950H2039.5V760H2145'
                      stroke='url(#paint72_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M745 570H849.5V380H955'
                      stroke='url(#paint73_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M575 380H679.5V190H785'
                      stroke='url(#paint74_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                    <path
                      d='M235 380H339.5V190H445'
                      stroke='url(#paint75_linear_336_819)'
                      stroke-width='4'
                      className='wire'
                    />
                  </g>
                  <defs>
                    <linearGradient
                      id='paint0_linear_336_819'
                      x1='293.971'
                      y1='795.526'
                      x2='423.741'
                      y2='795.054'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint1_linear_336_819'
                      x1='109.498'
                      y1='1170.62'
                      x2='238.448'
                      y2='1170.14'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint2_linear_336_819'
                      x1='465.37'
                      y1='1172.7'
                      x2='577.655'
                      y2='1172.34'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint3_linear_336_819'
                      x1='106.341'
                      y1='607.108'
                      x2='229.827'
                      y2='606.682'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint4_linear_336_819'
                      x1='811.29'
                      y1='983.362'
                      x2='926.034'
                      y2='982.991'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint5_linear_336_819'
                      x1='641.29'
                      y1='1362.2'
                      x2='756.034'
                      y2='1361.83'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint6_linear_336_819'
                      x1='811.29'
                      y1='1361.2'
                      x2='926.034'
                      y2='1360.83'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint7_linear_336_819'
                      x1='981.29'
                      y1='1361.2'
                      x2='1096.03'
                      y2='1360.83'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint8_linear_336_819'
                      x1='1151.29'
                      y1='1361.2'
                      x2='1266.03'
                      y2='1360.83'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint9_linear_336_819'
                      x1='1321.29'
                      y1='1361.2'
                      x2='1436.03'
                      y2='1360.83'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint10_linear_336_819'
                      x1='1491.29'
                      y1='1361.2'
                      x2='1606.03'
                      y2='1360.83'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint11_linear_336_819'
                      x1='1661.29'
                      y1='1361.2'
                      x2='1776.03'
                      y2='1360.83'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint12_linear_336_819'
                      x1='1831.29'
                      y1='1361.2'
                      x2='1946.03'
                      y2='1360.83'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint13_linear_336_819'
                      x1='1151.29'
                      y1='1172.2'
                      x2='1266.03'
                      y2='1171.83'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint14_linear_336_819'
                      x1='2001.29'
                      y1='1361.2'
                      x2='2116.03'
                      y2='1360.83'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint15_linear_336_819'
                      x1='1321.29'
                      y1='1171.2'
                      x2='1436.03'
                      y2='1170.83'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint16_linear_336_819'
                      x1='1491.29'
                      y1='1171.2'
                      x2='1606.03'
                      y2='1170.83'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint17_linear_336_819'
                      x1='1831.29'
                      y1='1171.2'
                      x2='1946.03'
                      y2='1170.83'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint18_linear_336_819'
                      x1='1661.29'
                      y1='1171.2'
                      x2='1776.03'
                      y2='1170.83'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint19_linear_336_819'
                      x1='1321.29'
                      y1='982.198'
                      x2='1436.03'
                      y2='981.825'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint20_linear_336_819'
                      x1='1491.29'
                      y1='982.198'
                      x2='1606.03'
                      y2='981.825'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint21_linear_336_819'
                      x1='1661.29'
                      y1='981.198'
                      x2='1776.03'
                      y2='980.825'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint22_linear_336_819'
                      x1='1831.29'
                      y1='981.198'
                      x2='1946.03'
                      y2='980.825'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint23_linear_336_819'
                      x1='2001.29'
                      y1='981.198'
                      x2='2116.03'
                      y2='980.825'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint24_linear_336_819'
                      x1='1321.29'
                      y1='792.198'
                      x2='1436.03'
                      y2='791.825'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint25_linear_336_819'
                      x1='1491.29'
                      y1='792.198'
                      x2='1606.03'
                      y2='791.825'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint26_linear_336_819'
                      x1='1661.29'
                      y1='791.198'
                      x2='1776.03'
                      y2='790.825'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint27_linear_336_819'
                      x1='1831.29'
                      y1='791.198'
                      x2='1946.03'
                      y2='790.825'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint28_linear_336_819'
                      x1='2001.29'
                      y1='791.198'
                      x2='2116.03'
                      y2='790.825'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint29_linear_336_819'
                      x1='1321.29'
                      y1='601.198'
                      x2='1436.03'
                      y2='600.825'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint30_linear_336_819'
                      x1='1491.29'
                      y1='601.198'
                      x2='1606.03'
                      y2='600.825'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint31_linear_336_819'
                      x1='1661.29'
                      y1='600.198'
                      x2='1776.03'
                      y2='599.825'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint32_linear_336_819'
                      x1='1491.29'
                      y1='600.198'
                      x2='1606.03'
                      y2='599.825'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint33_linear_336_819'
                      x1='1661.29'
                      y1='600.198'
                      x2='1776.03'
                      y2='599.825'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint34_linear_336_819'
                      x1='1831.29'
                      y1='601.198'
                      x2='1946.03'
                      y2='600.825'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint35_linear_336_819'
                      x1='2001.29'
                      y1='600.198'
                      x2='2116.03'
                      y2='599.825'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint36_linear_336_819'
                      x1='1321.29'
                      y1='414.198'
                      x2='1436.03'
                      y2='413.825'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint37_linear_336_819'
                      x1='1321.29'
                      y1='414.198'
                      x2='1436.03'
                      y2='413.825'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint38_linear_336_819'
                      x1='1831.29'
                      y1='411.198'
                      x2='1946.03'
                      y2='410.825'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint39_linear_336_819'
                      x1='2001.29'
                      y1='411.198'
                      x2='2116.03'
                      y2='410.825'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint40_linear_336_819'
                      x1='1661.29'
                      y1='414.198'
                      x2='1776.03'
                      y2='413.825'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint41_linear_336_819'
                      x1='1491.29'
                      y1='411.198'
                      x2='1606.03'
                      y2='410.825'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint42_linear_336_819'
                      x1='1491.29'
                      y1='411.198'
                      x2='1606.03'
                      y2='410.825'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint43_linear_336_819'
                      x1='1151.29'
                      y1='411.198'
                      x2='1266.03'
                      y2='410.825'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint44_linear_336_819'
                      x1='981.29'
                      y1='411.198'
                      x2='1096.03'
                      y2='410.825'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint45_linear_336_819'
                      x1='811.29'
                      y1='410.198'
                      x2='926.034'
                      y2='409.825'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint46_linear_336_819'
                      x1='641.29'
                      y1='411.198'
                      x2='756.034'
                      y2='410.825'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint47_linear_336_819'
                      x1='471.29'
                      y1='411.198'
                      x2='586.034'
                      y2='410.825'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint48_linear_336_819'
                      x1='299.29'
                      y1='411.198'
                      x2='414.034'
                      y2='410.825'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint49_linear_336_819'
                      x1='131.29'
                      y1='792.198'
                      x2='246.034'
                      y2='791.825'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint50_linear_336_819'
                      x1='131.29'
                      y1='981.198'
                      x2='246.034'
                      y2='980.825'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint51_linear_336_819'
                      x1='131.29'
                      y1='411.198'
                      x2='246.034'
                      y2='410.825'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint52_linear_336_819'
                      x1='301.29'
                      y1='983.362'
                      x2='416.034'
                      y2='982.991'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint53_linear_336_819'
                      x1='301.29'
                      y1='1363.36'
                      x2='416.034'
                      y2='1362.99'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint54_linear_336_819'
                      x1='471.29'
                      y1='1364.36'
                      x2='586.034'
                      y2='1363.99'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint55_linear_336_819'
                      x1='471.29'
                      y1='792.362'
                      x2='586.034'
                      y2='791.991'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint56_linear_336_819'
                      x1='471.29'
                      y1='983.362'
                      x2='586.034'
                      y2='982.991'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint57_linear_336_819'
                      x1='471.29'
                      y1='602.362'
                      x2='586.034'
                      y2='601.991'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint58_linear_336_819'
                      x1='811.29'
                      y1='603.362'
                      x2='926.034'
                      y2='602.991'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint59_linear_336_819'
                      x1='811.29'
                      y1='1172.36'
                      x2='926.034'
                      y2='1171.99'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint60_linear_336_819'
                      x1='981.29'
                      y1='1172.36'
                      x2='1096.03'
                      y2='1171.99'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint61_linear_336_819'
                      x1='1151.29'
                      y1='983.362'
                      x2='1266.03'
                      y2='982.991'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint62_linear_336_819'
                      x1='981.29'
                      y1='981.362'
                      x2='1096.03'
                      y2='980.991'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint63_linear_336_819'
                      x1='981.29'
                      y1='793.362'
                      x2='1096.03'
                      y2='792.991'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint64_linear_336_819'
                      x1='1151.29'
                      y1='793.362'
                      x2='1266.03'
                      y2='792.991'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint65_linear_336_819'
                      x1='1151.29'
                      y1='603.362'
                      x2='1266.03'
                      y2='602.991'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint66_linear_336_819'
                      x1='641.29'
                      y1='1172.36'
                      x2='756.034'
                      y2='1171.99'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint67_linear_336_819'
                      x1='641.29'
                      y1='794.362'
                      x2='756.034'
                      y2='793.991'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint68_linear_336_819'
                      x1='641.29'
                      y1='985.362'
                      x2='756.034'
                      y2='984.991'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint69_linear_336_819'
                      x1='981.29'
                      y1='602.362'
                      x2='1096.03'
                      y2='601.991'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint70_linear_336_819'
                      x1='132.29'
                      y1='1362.36'
                      x2='247.034'
                      y2='1361.99'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint71_linear_336_819'
                      x1='303.29'
                      y1='1173.36'
                      x2='418.034'
                      y2='1172.99'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint72_linear_336_819'
                      x1='2001.29'
                      y1='1171.2'
                      x2='2116.03'
                      y2='1170.83'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint73_linear_336_819'
                      x1='811.29'
                      y1='791.198'
                      x2='926.034'
                      y2='790.825'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint74_linear_336_819'
                      x1='641.29'
                      y1='601.198'
                      x2='756.034'
                      y2='600.825'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <linearGradient
                      id='paint75_linear_336_819'
                      x1='301.29'
                      y1='601.198'
                      x2='416.034'
                      y2='600.825'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stop-color='white' stop-opacity='0' />
                      <stop offset='0.747917' stop-color='#CFCBFF' />
                      <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                    </linearGradient>
                    <clipPath id='clip0_336_819'>
                      <rect width='2210' height='1140' fill='white' />
                    </clipPath>
                    <clipPath id='clip1_336_819'>
                      <rect width='2210' height='1140' fill='white' />
                    </clipPath>
                    <clipPath id='clip2_336_819'>
                      <rect width='2210' height='190' fill='white' />
                    </clipPath>
                    <clipPath id='clip3_336_819'>
                      <rect
                        width='2210'
                        height='190'
                        fill='white'
                        transform='translate(0 190)'
                      />
                    </clipPath>
                    <clipPath id='clip4_336_819'>
                      <rect
                        width='2210'
                        height='190'
                        fill='white'
                        transform='translate(0 380)'
                      />
                    </clipPath>
                    <clipPath id='clip5_336_819'>
                      <rect
                        width='2210'
                        height='190'
                        fill='white'
                        transform='translate(0 570)'
                      />
                    </clipPath>
                    <clipPath id='clip6_336_819'>
                      <rect
                        width='2210'
                        height='190'
                        fill='white'
                        transform='translate(0 760)'
                      />
                    </clipPath>
                    <clipPath id='clip7_336_819'>
                      <rect
                        width='2210'
                        height='190'
                        fill='white'
                        transform='translate(0 950)'
                      />
                    </clipPath>
                  </defs>
                </svg>
                {/* <div className={styles.bottomShadow}></div> */}
              </div>
            </>
          )}

          {window.innerWidth <= 768 && (
            <svg
              width='390'
              height='228'
              viewBox='0 0 390 228'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <g clip-path='url(#clip0_269_2519)'>
                <mask
                  id='mask0_269_2519'
                  style={{
                    maskType: "luminance",
                  }}
                  maskUnits='userSpaceOnUse'
                  x='-136'
                  y='-247'
                  width='683'
                  height='476'
                >
                  <path
                    d='M547 -246.22H-136V228.164H547V-246.22Z'
                    fill='white'
                  />
                </mask>
                <g mask='url(#mask0_269_2519)'>
                  <path
                    style={{ mixBlendMode: "screen" }}
                    d='M200.164 249.667C455.942 249.667 663.292 192.474 663.292 121.923C663.292 51.3725 455.942 -5.82031 200.164 -5.82031C-55.6154 -5.82031 -262.965 51.3725 -262.965 121.923C-262.965 192.474 -55.6154 249.667 200.164 249.667Z'
                    fill='url(#paint0_radial_269_2519)'
                  />
                  <g
                    style={{
                      mixBlendMode: "overlay",
                    }}
                  >
                    <path
                      d='M613.259 55.3369H-202.361L-202.634 55.3843H-202.334L-202.625 55.4413H-179.886L-179.613 55.3843H-179.021L-179.294 55.4413H-156.545L-156.29 55.3843H-155.698L-155.953 55.4413H-133.214L-132.977 55.3843H-132.376L-132.613 55.4413H-109.874L-109.655 55.3843H-109.063L-109.282 55.4413H-86.5334L-86.3331 55.3843H-85.7411L-85.9414 55.4413H-63.2021L-63.02 55.3843H-62.419L-62.6102 55.4413H-39.8708L-39.6978 55.3843H-39.0968L-39.2698 55.4413H-16.5305L-16.3756 55.3843H-15.7838L-15.9385 55.4413H6.80083L6.94656 55.3843H7.53851L7.40189 55.4413H30.1412L30.2596 55.3843H30.8516L30.7332 55.4413H53.4725L53.5818 55.3843H54.1737L54.0735 55.4413H76.8129L76.8948 55.3843H77.4959L77.4048 55.4413H100.144L100.217 55.3843H100.818L100.745 55.4413H123.475L123.539 55.3843H124.131L124.077 55.4413H146.816L146.861 55.3843H147.453L147.417 55.4413H170.147L170.174 55.3843H170.776L170.748 55.4413H193.487L193.497 55.3843H194.089L194.079 55.4413H216.819L216.81 55.3843H217.411L217.42 55.4413H240.159L240.132 55.3843H240.733L240.751 55.4413H263.5L263.454 55.3843H264.055L264.091 55.4413H286.831L286.776 55.3843H287.368L287.423 55.4413H310.171L310.098 55.3843H310.69L310.763 55.4413H333.503L333.411 55.3843H334.003L334.094 55.4413H356.843L356.734 55.3843H357.326L357.435 55.4413H380.174L380.047 55.3843H380.648L380.766 55.4413H403.515L403.369 55.3843H403.97L404.107 55.4413H426.846L426.691 55.3843H427.283L427.438 55.4413H450.186L450.013 55.3843H450.605L450.778 55.4413H473.517L473.326 55.3843H473.927L474.119 55.4413H496.858L496.648 55.3843H497.24L497.45 55.4413H520.189L519.971 55.3843H520.563L520.79 55.4413H543.52L543.293 55.3843H543.885L544.121 55.4413H566.861L566.606 55.3843H567.207L567.462 55.4413H590.192L589.928 55.3843H590.52L590.793 55.4413H613.532L613.25 55.3843H613.542L613.259 55.3369Z'
                      fill='white'
                    />
                    <path
                      d='M-185.72 81.5405H-208.805L-209.388 81.6449H-186.266L-185.71 81.5405M-162.015 81.5405H-185.109L-185.665 81.6449H-162.534L-162.015 81.5405ZM-138.319 81.5405H-161.405L-161.924 81.6449H-138.802L-138.319 81.5405ZM-114.624 81.5405H-137.709L-138.192 81.6449H-115.07L-114.615 81.5405M-90.9192 81.5405H-114.014L-114.469 81.6449H-91.3471L-90.9283 81.5405M-67.2327 81.5405H-90.3181L-90.737 81.6449H-67.6151L-67.2327 81.5405ZM-43.5371 81.5405H-66.6316L-67.0142 81.6449H-43.8923L-43.5371 81.5405ZM-19.8416 81.5405H-42.927L-43.2821 81.6449H-20.1603L-19.8416 81.5405ZM3.85399 81.5405H-19.2405L-19.5593 81.6449H3.56252L3.84488 81.5405M27.5404 81.5405H4.45496L4.1727 81.6449H27.2945L27.5496 81.5405M51.245 81.5405H28.1505L27.9046 81.6449H51.0265L51.245 81.5405ZM74.9406 81.5405H51.8552L51.6367 81.6449H74.7585L74.9406 81.5405ZM98.6361 81.5405H75.5417L75.3596 81.6449H98.4813L98.6361 81.5405ZM122.332 81.5405H99.2463L99.1006 81.6449H122.222L122.341 81.5405M146.036 81.5405H122.942L122.824 81.6449H145.945L146.027 81.5405M169.723 81.5405H146.637L146.555 81.6449H169.677L169.732 81.5405M193.427 81.5405H170.342L170.297 81.6449H193.418L193.437 81.5405M217.132 81.5405H194.047L194.028 81.6449H217.15L217.132 81.5405ZM240.828 81.5405H217.742L217.76 81.6449H240.882L240.837 81.5405M264.532 81.5405H241.438L241.492 81.6449H264.614L264.532 81.5405ZM288.228 81.5405H265.142L265.224 81.6449H288.346L288.228 81.5405ZM311.923 81.5405H288.829L288.947 81.6449H312.078L311.932 81.5405M335.628 81.5405H312.543L312.698 81.6449H335.819L335.637 81.5405M359.333 81.5405H336.238L336.42 81.6449H359.551L359.333 81.5405ZM383.028 81.5405H359.943L360.161 81.6449H383.283L383.028 81.5405ZM406.724 81.5405H383.629L383.884 81.6449H407.006L406.724 81.5405ZM430.419 81.5405H407.334L407.616 81.6449H430.738L430.419 81.5405ZM454.115 81.5405H431.02L431.339 81.6449H454.461L454.106 81.5405M477.801 81.5405H454.716L455.071 81.6449H478.193L477.81 81.5405M501.506 81.5405H478.421L478.803 81.6449H501.925L501.506 81.5405ZM525.202 81.5405H502.116L502.535 81.6449H525.657L525.202 81.5405ZM548.897 81.5405H525.812L526.267 81.6449H549.389L548.906 81.5405M572.602 81.5405H549.507L549.99 81.6449H573.121L572.602 81.5405ZM596.297 81.5405H573.212L573.731 81.6449H596.853L596.297 81.5405ZM619.993 81.5405H596.898L597.454 81.6449H620.585L620.002 81.5405'
                      fill='white'
                    />
                    <path
                      d='M-192.504 107.744H-215.99L-216.591 107.858H-193.078L-192.504 107.744ZM-168.399 107.744H-191.885L-192.459 107.858H-168.936L-168.399 107.744ZM-144.303 107.744H-167.789L-168.326 107.858H-144.812L-144.312 107.744M-120.206 107.744H-143.692L-144.193 107.858H-120.68L-120.215 107.744M-96.11 107.744H-119.596L-120.061 107.858H-96.538L-96.1009 107.744M-72.0047 107.744H-95.4907L-95.9188 107.858H-72.4053L-72.0047 107.744ZM-47.8992 107.744H-71.3854L-71.7861 107.858H-48.2635L-47.8992 107.744ZM-23.803 107.744H-47.2892L-47.6535 107.858H-24.14L-23.8122 107.744M0.293152 107.744H-23.193L-23.5208 107.858H0.00178528L0.293152 107.744ZM24.3894 107.744H0.903351L0.611862 107.858H24.1253L24.3894 107.744ZM48.4948 107.744H25.0087L24.7536 107.858H48.2762L48.5039 107.744M72.6001 107.744H49.114L48.8863 107.858H72.3998L72.591 107.744M96.6963 107.744H73.2103L73.019 107.858H96.5416L96.6963 107.744ZM120.793 107.744H97.3065L97.1516 107.858H120.665L120.784 107.744M144.889 107.744H121.403L121.284 107.858H144.807L144.898 107.744M168.994 107.744H145.508L145.426 107.858H168.94L168.994 107.744ZM193.099 107.744H169.613L169.559 107.858H193.072L193.09 107.744M217.187 107.744H193.701L193.682 107.858H217.196L217.178 107.744M241.283 107.744H217.797L217.815 107.858H241.328L241.274 107.744M265.379 107.744H241.893L241.948 107.858H265.47L265.388 107.744M289.484 107.744H265.998L266.089 107.858H289.603L289.484 107.744ZM313.59 107.744H290.104L290.222 107.858H313.745L313.59 107.744ZM337.686 107.744H314.2L314.355 107.858H337.868L337.677 107.744M361.782 107.744H338.296L338.487 107.858H362.01L361.782 107.744ZM385.879 107.744H362.392L362.62 107.858H386.134L385.879 107.744ZM409.984 107.744H386.498L386.762 107.858H410.284L409.993 107.744M434.089 107.744H410.603L410.895 107.858H434.408L434.08 107.744M458.185 107.744H434.699L435.027 107.858H458.55L458.185 107.744ZM482.282 107.744H458.796L459.16 107.858H482.673L482.273 107.744M506.378 107.744H482.892L483.293 107.858H506.806L506.378 107.744ZM530.474 107.744H506.988L507.425 107.858H530.939L530.474 107.744ZM554.58 107.744H531.093L531.558 107.858H555.071L554.57 107.744M578.676 107.744H555.19L555.691 107.858H579.213L578.676 107.744ZM602.772 107.744H579.286L579.823 107.858H603.337L602.763 107.744M626.868 107.744H603.382L603.956 107.858H627.478L626.877 107.744'
                      fill='white'
                    />
                    <path
                      d='M-199.28 133.958H-223.167L-223.795 134.071H-199.872L-199.28 133.958ZM-174.756 133.958H-198.652L-199.244 134.071H-175.311L-174.756 133.958ZM-150.24 133.958H-174.127L-174.683 134.071H-150.76L-150.24 133.958ZM-125.716 133.958H-149.603L-150.122 134.071H-126.199L-125.716 133.958ZM-101.192 133.958H-125.088L-125.571 134.071H-101.638L-101.192 133.958ZM-76.6768 133.958H-100.564L-101.01 134.071H-77.0867L-76.6768 133.958ZM-52.1526 133.958H-76.0485L-76.4582 134.071H-52.526L-52.1526 133.958ZM-27.6374 133.958H-51.5242L-51.8976 134.071H-27.9743L-27.6374 133.958ZM-3.11322 133.958H-27.0091L-27.3461 134.071H-3.4137L-3.11322 133.958ZM21.402 133.958H-2.4848L-2.7854 134.071H21.1378L21.4111 133.958M45.9353 133.958H22.0394L21.7754 134.071H45.7076L45.9444 133.958M70.4596 133.958H46.5728L46.336 134.071H70.2592L70.4596 133.958ZM94.9839 133.958H71.088L70.8876 134.071H94.8199L94.9839 133.958ZM119.499 133.958H95.6122L95.4483 134.071H119.371L119.499 133.958ZM144.023 133.958H120.127L120 134.071H143.932L144.023 133.958ZM168.538 133.958H144.652L144.561 134.071H168.484L168.538 133.958ZM193.063 133.958H169.176L169.121 134.071H193.044L193.063 133.958ZM217.578 133.958H193.691L193.673 134.071H217.596L217.578 133.958ZM242.102 133.958H218.215L218.233 134.071H242.157L242.102 133.958ZM266.626 133.958H242.73L242.785 134.071H266.717L266.626 133.958ZM291.141 133.958H267.255L267.346 134.071H291.269L291.141 133.958ZM315.666 133.958H291.77L291.897 134.071H315.83L315.666 133.958ZM340.181 133.958H316.294L316.458 134.071H340.381L340.181 133.958ZM364.705 133.958H340.809L341.01 134.071H364.942L364.705 133.958ZM389.22 133.958H365.333L365.57 134.071H389.493L389.229 133.958M413.754 133.958H389.858L390.131 134.071H414.063L413.763 133.958M438.278 133.958H414.391L414.692 134.071H438.615L438.278 133.958ZM462.802 133.958H438.906L439.243 134.071H463.175L462.802 133.958ZM487.317 133.958H463.43L463.804 134.071H487.727L487.317 133.958ZM511.842 133.958H487.955L488.365 134.071H512.288L511.842 133.958ZM536.357 133.958H512.47L512.916 134.071H536.839L536.357 133.958ZM560.881 133.958H536.994L537.477 134.071H561.4L560.881 133.958ZM585.405 133.958H561.509L562.028 134.071H585.961L585.405 133.958ZM609.92 133.958H586.034L586.589 134.071H610.512L609.92 133.958ZM634.445 133.958H610.549L611.141 134.071H635.073L634.445 133.958Z'
                      fill='white'
                    />
                    <path
                      d='M-206.487 160.171H-230.802L-231.449 160.294H-207.098L-206.487 160.171ZM-181.535 160.171H-205.859L-206.469 160.294H-182.109L-181.535 160.171ZM-156.583 160.171H-180.898L-181.471 160.294H-157.12L-156.583 160.171ZM-131.631 160.171H-155.945L-156.483 160.294H-132.132L-131.631 160.171ZM-106.678 160.171H-131.002L-131.503 160.294H-107.152L-106.687 160.171M-81.7352 160.171H-106.05L-106.514 160.294H-82.1633L-81.7352 160.171ZM-56.783 160.171H-81.1069L-81.5349 160.294H-57.1836L-56.7921 160.171M-31.8398 160.171H-56.1546L-56.5462 160.294H-32.195L-31.8398 160.171ZM-6.88753 160.171H-31.2114L-31.5666 160.294H-7.21536L-6.89665 160.171M18.0556 160.171H-6.25911L-6.57794 160.294H17.7733L18.0556 160.171ZM43.0079 160.171H18.6839L18.4017 160.294H42.762L43.0079 160.171ZM67.9602 160.171H43.6454L43.4086 160.294H67.7598L67.9602 160.171ZM92.9124 160.171H68.5885L68.3882 160.294H92.7394L92.9033 160.171M117.856 160.171H93.5408L93.3768 160.294H117.728L117.856 160.171ZM142.808 160.171H118.484L118.356 160.294H142.717L142.808 160.171ZM167.76 160.171H143.445L143.354 160.294H167.705L167.76 160.171ZM192.712 160.171H168.398L168.343 160.294H192.694L192.712 160.171ZM217.665 160.171H193.35L193.332 160.294H217.683L217.665 160.171ZM242.617 160.171H218.302L218.32 160.294H242.672L242.617 160.171ZM267.569 160.171H243.245L243.3 160.294H267.651L267.56 160.171M292.512 160.171H268.198L268.289 160.294H292.64L292.512 160.171ZM317.465 160.171H293.141L293.268 160.294H317.628L317.465 160.171ZM342.417 160.171H318.102L318.266 160.294H342.617L342.417 160.171ZM367.369 160.171H343.045L343.246 160.294H367.606L367.369 160.171ZM392.321 160.171H368.007L368.253 160.294H392.604L392.321 160.171ZM417.274 160.171H392.95L393.232 160.294H417.583L417.265 160.171M442.217 160.171H417.902L418.221 160.294H442.572L442.217 160.171ZM467.169 160.171H442.845L443.2 160.294H467.561L467.169 160.171ZM492.121 160.171H467.807L468.198 160.294H492.549L492.121 160.171ZM517.074 160.171H492.759L493.187 160.294H517.538L517.074 160.171ZM542.026 160.171H517.711L518.176 160.294H542.527L542.026 160.171ZM566.978 160.171H542.663L543.164 160.294H567.515L566.978 160.171ZM591.93 160.171H567.607L568.144 160.294H592.504L591.93 160.171ZM616.883 160.171H592.568L593.142 160.294H617.493L616.883 160.171ZM641.835 160.171H617.511L618.121 160.294H642.482L641.835 160.171Z'
                      fill='white'
                    />
                    <path
                      d='M-214.127 186.394H-238.879L-239.553 186.517H-214.765L-214.127 186.394ZM-188.72 186.394H-213.481L-214.118 186.517H-189.321L-188.729 186.394M-163.331 186.394H-188.082L-188.674 186.517H-163.886L-163.331 186.394ZM-137.923 186.394H-162.675L-163.23 186.517H-138.442L-137.923 186.394ZM-112.515 186.394H-137.276L-137.795 186.517H-112.998L-112.515 186.394ZM-87.1168 186.394H-111.869L-112.351 186.517H-87.563L-87.1168 186.394ZM-61.7092 186.394H-86.4702L-86.9073 186.517H-62.1099L-61.7092 186.394ZM-36.3107 186.394H-61.0626L-61.4633 186.517H-36.6749L-36.3107 186.394ZM-10.9031 186.394H-35.6641L-36.0284 186.517H-11.231L-10.9031 186.394ZM14.4954 186.394H-10.2565L-10.5843 186.517H14.204L14.4954 186.394ZM39.903 186.394H15.142L14.8505 186.517H39.648L39.8939 186.394M65.2924 186.394H40.5405L40.2946 186.517H65.0829L65.2924 186.394ZM90.7 186.394H65.9389L65.7295 186.517H90.5269L90.7 186.394ZM116.099 186.394H91.3465L91.1736 186.517H115.962L116.099 186.394ZM141.506 186.394H116.745L116.608 186.517H141.406L141.506 186.394ZM166.905 186.394H142.153L142.062 186.517H166.85L166.905 186.394ZM192.312 186.394H167.56L167.506 186.517H192.294L192.312 186.394ZM217.711 186.394H192.959L192.941 186.517H217.729L217.711 186.394ZM243.118 186.394H218.366L218.385 186.517H243.173L243.118 186.394ZM268.526 186.394H243.765L243.819 186.517H268.617L268.526 186.394ZM293.924 186.394H269.172L269.273 186.517H294.061L293.924 186.394ZM319.332 186.394H294.571L294.708 186.517H319.505L319.332 186.394ZM344.73 186.394H319.979L320.152 186.517H344.94L344.73 186.394ZM370.138 186.394H345.377L345.586 186.517H370.384L370.138 186.394ZM395.537 186.394H370.785L371.03 186.517H395.819L395.527 186.394M420.935 186.394H396.174L396.465 186.517H421.263L420.935 186.394ZM446.334 186.394H421.582L421.909 186.517H446.698L446.334 186.394ZM471.741 186.394H446.98L447.344 186.517H472.142L471.741 186.394ZM497.14 186.394H472.388L472.788 186.517H497.577L497.13 186.394M522.538 186.394H497.786L498.232 186.517H523.021L522.538 186.394ZM547.937 186.394H523.185L523.667 186.517H548.456L547.937 186.394ZM573.344 186.394H548.592L549.111 186.517H573.9L573.344 186.394ZM598.752 186.394H573.991L574.546 186.517H599.344L598.752 186.394ZM624.15 186.394H599.398L599.999 186.517H624.788L624.15 186.394ZM649.558 186.394H624.797L625.434 186.517H650.232L649.558 186.394Z'
                      fill='white'
                    />
                    <path
                      d='M-929.246 203.345H-996.207L-1001.14 204.265H-933.908L-929.246 203.345ZM-860.518 203.345H-927.497L-932.151 204.265H-864.898L-860.518 203.345ZM-791.808 203.345H-858.769L-863.14 204.265H-795.906L-791.808 203.345ZM-723.08 203.345H-790.041L-794.13 204.265H-726.895L-723.08 203.345ZM-654.352 203.345H-721.331L-725.138 204.265H-657.885L-654.352 203.345ZM-585.642 203.345H-652.603L-656.128 204.265H-588.893L-585.642 203.345ZM-516.914 203.345H-583.893L-587.135 204.265H-519.883L-516.914 203.345ZM-448.204 203.345H-515.165L-518.125 204.265H-450.891L-448.204 203.345ZM-379.476 203.345H-446.456L-449.133 204.265H-381.88L-379.476 203.345ZM-310.766 203.345H-377.728L-380.123 204.265H-312.888L-310.766 203.345ZM-242.038 203.345H-309.018L-311.13 204.265H-243.878L-242.038 203.345ZM-173.328 203.345H-240.29L-242.12 204.265H-174.886L-173.328 203.345ZM-104.6 203.345H-171.58L-173.128 204.265H-105.875L-104.6 203.345ZM-35.8906 203.345H-102.852L-104.118 204.265H-36.8832L-35.8906 203.345ZM32.8375 203.345H-34.1421L-35.1256 204.265H32.1271L32.8375 203.345ZM101.547 203.345H34.5859L33.8848 204.265H101.119L101.547 203.345ZM170.275 203.345H103.314L102.895 204.265H170.13L170.275 203.345ZM238.985 203.345H172.024L171.887 204.265H239.122L238.985 203.345ZM307.713 203.345H240.752L240.897 204.265H308.132L307.713 203.345ZM376.441 203.345H309.462L309.89 204.265H377.142L376.441 203.345ZM445.151 203.345H378.19L378.9 204.265H446.134L445.151 203.345ZM513.879 203.345H446.899L447.892 204.265H515.145L513.879 203.345ZM582.589 203.345H515.627L516.902 204.265H584.137L582.589 203.345ZM651.317 203.345H584.337L585.894 204.265H653.147L651.317 203.345ZM720.027 203.345H653.065L654.905 204.265H722.139L720.027 203.345ZM788.755 203.345H721.775L723.897 204.265H791.15L788.755 203.345ZM857.464 203.345H790.503L792.907 204.265H860.142L857.464 203.345ZM926.192 203.345H859.213L861.899 204.265H929.152L926.192 203.345ZM994.902 203.345H927.941L930.91 204.265H998.144L994.902 203.345ZM1063.63 203.345H996.669L999.92 204.265H1067.15L1063.63 203.345ZM1132.34 203.345H1065.38L1068.91 204.265H1136.15L1132.34 203.345ZM1201.07 203.345H1134.11L1137.92 204.265H1205.16L1201.07 203.345ZM1269.8 203.345H1202.82L1206.91 204.265H1274.17L1269.8 203.345ZM1338.51 203.345H1271.54L1275.92 204.265H1343.16L1338.51 203.345ZM1407.23 203.345H1340.25L1344.92 204.265H1412.17L1407.23 203.345Z'
                      fill='white'
                    />
                    <path
                      d='M1536.92 227.52H1462.72L1465.6 228.089H1463.66L1460.78 227.52H1386.59L1389.29 228.089H1387.35L1384.65 227.52H1310.45L1312.98 228.089H1311.03L1308.51 227.52H1234.32L1236.67 228.089H1234.72L1232.36 227.52H1158.17L1160.35 228.089H1158.41L1156.24 227.52H1082.04L1084.06 228.089H1082.1L1080.09 227.52H1005.9L1007.73 228.089H1005.79L1003.96 227.52H929.761L931.419 228.089H929.47L927.822 227.52H853.63L855.114 228.089H853.174L851.69 227.52H777.489L778.791 228.089H776.851L775.549 227.52H701.357L702.495 228.089H700.547L699.417 227.52H625.216L626.172 228.089H624.233L623.276 227.52H549.084L549.877 228.089H547.928L547.145 227.52H472.943L473.554 228.089H471.614L471.004 227.52H396.812L397.249 228.089H395.309L394.872 227.52H320.671L320.935 228.089H318.986L318.731 227.52H244.539L244.63 228.089H242.672L242.59 227.52H168.398L168.317 228.089H166.368L166.459 227.52H92.2667L92.0117 228.089H90.0538L90.3179 227.52H16.126L15.6887 228.089H13.749L14.1862 227.52H-60.015L-60.6251 228.089H-62.574L-61.9547 227.52H-136.147L-136.93 228.089H-138.87L-138.086 227.52H-212.288L-213.244 228.089H-215.193L-214.227 227.52H-288.419L-289.548 228.089H-291.488L-290.359 227.52H-364.56L-365.871 228.089H-367.811L-366.5 227.52H-440.692L-442.167 228.089H-444.116L-442.632 227.52H-516.833L-518.49 228.089H-520.43L-518.772 227.52H-592.964L-594.786 228.089H-596.735L-594.904 227.52H-669.105L-671.109 228.089H-673.048L-671.045 227.52H-745.237L-747.413 228.089H-749.353L-747.168 227.52H-821.378L-823.727 228.089H-825.676L-823.318 227.52H-897.5L-900.032 228.089H-901.99L-899.458 227.52H-973.65L-976.346 228.089H-978.295L-975.59 227.52H-1049.79L-1052.67 228.089H-1054.61L-1051.73 227.52H-1125.92L-1128.97 228.089H-1129.95L-1132.96 228.649H1543.94L1540.94 228.089H1539.97L1536.92 227.52Z'
                      fill='white'
                    />
                    <path
                      d='M7.58432 55.3843H6.99237L6.84662 55.4412L3.7959 56.6082L3.51355 56.722L0.344452 57.927L0.0531006 58.0408L-3.21628 59.2932L-3.52588 59.4165L-6.91354 60.7069L-7.23224 60.8302L-10.7383 62.1775L-11.0662 62.3008L-14.6998 63.6955L-15.0458 63.8188L-18.816 65.2705L-19.1711 65.4033L-23.087 66.9023L-23.4513 67.0447L-27.5219 68.6006L-27.9044 68.7429L-32.1389 70.3653L-32.5306 70.5171L-36.9382 72.206L-37.3481 72.3577L-41.9286 74.113L-42.3567 74.2838L-47.1377 76.1054L-47.584 76.2762L-52.5653 78.1927L-53.0297 78.3635L-58.2387 80.3559L-58.7214 80.5456L-64.158 82.6234L-64.6681 82.8227L-70.3506 84.9953L-70.8879 85.2041L-76.8437 87.4811L-77.3992 87.6993L-83.6372 90.0808L-84.2292 90.3085L-90.7768 92.8132L-91.3961 93.0504L-98.2717 95.688L-98.9182 95.9346L-106.158 98.7051L-106.832 98.9612L-114.463 101.883L-115.183 102.159L-123.224 105.242L-123.98 105.527L-132.476 108.781L-133.269 109.085L-142.266 112.529L-143.113 112.851L-152.638 116.494L-153.54 116.846L-163.648 120.716L-164.605 121.077L-175.36 125.195L-176.37 125.584L-187.836 129.976L-188.919 130.384L-201.159 135.071L-202.315 135.517L-215.42 140.536L-216.658 141.011L-230.701 146.381L-232.049 146.903L-247.147 152.68L-248.586 153.231L-264.887 159.474L-266.435 160.062L-284.075 166.817L-285.751 167.462L-304.875 174.777L-306.714 175.479L-327.532 183.459L-329.526 184.218L-352.302 192.937L-354.488 193.772L-379.485 203.345L-381.881 204.265L-409.428 214.806L-412.106 215.831L-442.631 227.519L-444.116 228.089H-442.167L-440.691 227.519L-410.257 215.831L-407.589 214.806L-380.132 204.265L-377.737 203.345L-352.812 193.772L-350.636 192.937L-327.924 184.218L-325.938 183.459L-305.184 175.479L-303.345 174.777L-284.284 167.462L-282.609 166.817L-265.024 160.062L-263.485 159.474L-247.229 153.231L-245.8 152.68L-230.737 146.903L-229.399 146.381L-215.402 141.011L-214.163 140.536L-201.095 135.517L-199.948 135.071L-187.736 130.384L-186.661 129.976L-175.232 125.584L-174.212 125.195L-163.503 121.077L-162.547 120.716L-152.465 116.846L-151.564 116.494L-142.066 112.851L-141.228 112.529L-132.258 109.085L-131.465 108.781L-122.996 105.527L-122.24 105.242L-114.217 102.159L-113.507 101.883L-105.903 98.9612L-105.22 98.7051L-98.0076 95.9346L-97.361 95.688L-90.5037 93.0504L-89.8935 92.8132L-83.364 90.3085L-82.7721 90.0808L-76.5522 87.6993L-75.9967 87.4811L-70.0591 85.2041L-69.531 84.9953L-63.8575 82.8227L-63.3566 82.6234L-57.9291 80.5456L-57.4464 80.3559L-52.2557 78.3635L-51.7912 78.1927L-46.828 76.2762L-46.3818 76.1054L-41.619 74.2838L-41.191 74.113L-36.6195 72.3577L-36.2097 72.206L-31.8203 70.5171L-31.4287 70.3653L-27.2032 68.7429L-26.8207 68.6006L-22.7683 67.0447L-22.404 66.9023L-18.4972 65.4033L-18.142 65.2705L-14.381 63.8188L-14.044 63.6955L-10.4105 62.3008L-10.0918 62.1775L-6.59482 60.8302L-6.27612 60.7069L-2.89746 59.4165L-2.59698 59.2932L0.672272 58.0408L0.963745 57.927L4.11462 56.722L4.39697 56.6082L7.44769 55.4412L7.58432 55.3843Z'
                      fill='white'
                    />
                    <path
                      d='M30.897 55.3843H30.3051L30.1867 55.4412L27.4911 56.6082L27.2361 56.722L24.4403 57.927L24.1854 58.0408L21.2986 59.2932L21.0253 59.4165L18.0384 60.7069L17.7561 60.8302L14.6598 62.1775L14.3775 62.3008L11.1628 63.6955L10.8624 63.8188L7.5293 65.2705L7.2197 65.4033L3.75912 66.9023L3.4404 67.0447L-0.156677 68.6006L-0.484619 68.7429L-4.22745 70.3653L-4.57352 70.5171L-8.46194 72.206L-8.82623 72.3577L-12.8697 74.113L-13.2521 74.2838L-17.4594 76.1054L-17.8601 76.2762L-22.2586 78.1927L-22.6685 78.3635L-27.2581 80.3559L-27.6862 80.5456L-32.4854 82.6234L-32.9407 82.8227L-37.9493 84.9953L-38.4229 85.2041L-43.6775 87.4811L-44.1693 87.6993L-49.6787 90.0808L-50.1979 90.3085L-55.9806 92.8132L-56.5179 93.0504L-62.592 95.688L-63.1566 95.9346L-69.5496 98.7051L-70.1506 98.9612L-76.8804 101.883L-77.5179 102.159L-84.612 105.242L-85.2859 105.527L-92.7715 108.781L-93.4819 109.085L-101.414 112.529L-102.16 112.851L-110.575 116.494L-111.367 116.846L-120.292 120.716L-121.139 121.077L-130.619 125.195L-131.52 125.584L-141.638 129.976L-142.594 130.384L-153.395 135.071L-154.415 135.517L-165.98 140.536L-167.073 141.011L-179.467 146.381L-180.66 146.903L-193.983 152.68L-195.249 153.231L-209.637 159.474L-211.003 160.062L-226.567 166.817L-228.051 167.462L-244.926 174.777L-246.547 175.479L-264.924 183.459L-266.682 184.218L-286.78 192.937L-288.711 193.772L-310.776 203.345L-312.889 204.265L-337.204 214.806L-339.562 215.831L-366.5 227.519L-367.811 228.089H-365.871L-364.56 227.519L-337.714 215.831L-335.364 214.806L-311.131 204.265L-309.028 203.345L-287.035 193.772L-285.113 192.937L-265.079 184.218L-263.33 183.459L-245.017 175.479L-243.396 174.777L-226.585 167.462L-225.101 166.817L-209.592 160.062L-208.226 159.474L-193.892 153.231L-192.626 152.68L-179.349 146.903L-178.165 146.381L-165.816 141.011L-164.723 140.536L-153.194 135.517L-152.174 135.071L-141.41 130.384L-140.454 129.976L-130.373 125.584L-129.48 125.195L-120.028 121.077L-119.19 120.716L-110.293 116.846L-109.5 116.494L-101.122 112.851L-100.376 112.529L-92.471 109.085L-91.7607 108.781L-84.2932 105.527L-83.6284 105.242L-76.5525 102.159L-75.9242 101.883L-69.2126 98.9612L-68.6207 98.7051L-62.246 95.9346L-61.6814 95.688L-55.6346 93.0504L-55.0882 92.8132L-49.3327 90.3085L-48.8137 90.0808L-43.3223 87.6993L-42.8306 87.4811L-37.5943 85.2041L-37.1299 84.9953L-32.1303 82.8227L-31.684 82.6234L-26.894 80.5456L-26.4659 80.3559L-21.8943 78.3635L-21.4845 78.1927L-17.0952 76.2762L-16.7035 76.1054L-12.5054 74.2838L-12.132 74.113L-8.09778 72.3577L-7.73349 72.206L-3.86316 70.5171L-3.51709 70.3653L0.207489 68.7429L0.544434 68.6006L4.12341 67.0447L4.44211 66.9023L7.89359 65.4033L8.20319 65.2705L11.518 63.8188L11.8185 63.6955L15.024 62.3008L15.3064 62.1775L18.3936 60.8302L18.6758 60.7069L21.6537 59.4165L21.9179 59.2932L24.7955 58.0408L25.0596 57.927L27.8372 56.722L28.0921 56.6082L30.7787 55.4412L30.897 55.3843Z'
                      fill='white'
                    />
                    <path
                      d='M54.2193 55.3843H53.6273L53.5181 55.4412L51.1868 56.6082L50.9681 56.722L48.5459 57.927L48.3182 58.0408L45.8138 59.2932L45.5862 59.4165L42.9908 60.7069L42.754 60.8302L40.0675 62.1775L39.8125 62.3008L37.035 63.6955L36.7709 63.8188L33.8842 65.2705L33.6109 65.4033L30.6148 66.9023L30.3325 67.0447L27.2271 68.6006L26.9358 68.7429L23.6937 70.3653L23.3932 70.5171L20.0237 72.206L19.705 72.3577L16.1989 74.113L15.8711 74.2838L12.2194 76.1054L11.8733 76.2762L8.06665 78.1927L7.71149 78.3635L3.72275 80.3559L3.34946 80.5456L-0.803223 82.6234L-1.19476 82.8227L-5.54776 84.9953L-5.94852 85.2041L-10.5109 87.4811L-10.9298 87.6993L-15.7108 90.0808L-16.157 90.3085L-21.1657 92.8132L-21.6393 93.0504L-26.9029 95.688L-27.3947 95.9346L-32.9316 98.7051L-33.4597 98.9612L-39.288 101.883L-39.8435 102.159L-45.9905 105.242L-46.5733 105.527L-53.0664 108.781L-53.6856 109.085L-60.5612 112.529L-61.2077 112.851L-68.5022 116.494L-69.1852 116.846L-76.9258 120.716L-77.6544 121.077L-85.8776 125.195L-86.6518 125.584L-95.4215 129.976L-96.2501 130.384L-105.621 135.071L-106.504 135.517L-116.531 140.536L-117.478 141.011L-128.224 146.381L-129.253 146.903L-140.8 152.68L-141.902 153.231L-154.378 159.474L-155.562 160.062L-169.049 166.817L-170.333 167.462L-184.967 174.777L-186.37 175.479L-202.297 183.459L-203.827 184.218L-221.248 192.937L-222.924 193.772L-242.048 203.345L-243.887 204.265L-264.951 214.806L-267 215.831L-290.359 227.519L-291.488 228.089H-289.548L-288.419 227.519L-265.161 215.831L-263.112 214.806L-242.13 204.265L-240.299 203.345L-221.248 193.772L-219.582 192.937L-202.224 184.218L-200.704 183.459L-184.84 175.479L-183.437 174.777L-168.867 167.462L-167.583 166.817L-154.15 160.062L-152.966 159.474L-140.545 153.231L-139.452 152.68L-127.941 146.903L-126.912 146.381L-116.212 141.011L-115.265 140.536L-105.284 135.517L-104.401 135.071L-95.0755 130.384L-94.2467 129.976L-85.5135 125.584L-84.7393 125.195L-76.5433 121.077L-75.8148 120.716L-68.1105 116.846L-67.4275 116.494L-60.1695 112.851L-59.523 112.529L-52.6656 109.085L-52.0556 108.781L-45.5898 105.527L-45.0069 105.242L-38.8781 102.159L-38.3318 101.883L-32.5217 98.9612L-32.0027 98.7051L-26.484 95.9346L-25.9922 95.688L-20.7559 93.0504L-20.2824 92.8132L-15.2918 90.3085L-14.8456 90.0808L-10.092 87.6993L-9.664 87.4811L-5.11978 85.2041L-4.71902 84.9953L-0.384247 82.8227L-0.00183105 82.6234L4.14175 80.5456L4.51514 80.3559L8.47653 78.3635L8.8317 78.1927L12.6382 76.2762L12.9752 76.1054L16.6178 74.2838L16.9366 74.113L20.4336 72.3577L20.7523 72.206L24.1035 70.5171L24.4041 70.3653L27.6277 68.7429L27.9192 68.6006L31.0246 67.0447L31.2978 66.9023L34.2848 65.4033L34.558 65.2705L37.4357 63.8188L37.6907 63.6955L40.4683 62.3008L40.7141 62.1775L43.3914 60.8302L43.6282 60.7069L46.2054 59.4165L46.4422 59.2932L48.9374 58.0408L49.165 57.927L51.5692 56.722L51.7878 56.6082L54.1191 55.4412L54.2193 55.3843Z'
                      fill='white'
                    />
                    <path
                      d='M77.5415 55.3843H76.9405L76.8586 55.4412L74.8732 56.6082L74.6912 56.722L72.6422 57.927L72.451 58.0408L70.329 59.2932L70.1378 59.4165L67.9431 60.7069L67.7336 60.8302L65.4661 62.1775L65.2567 62.3008L62.8981 63.6955L62.6795 63.8188L60.2298 65.2705L60.0021 65.4033L57.4704 66.9023L57.2245 67.0447L54.5928 68.6006L54.3469 68.7429L51.6058 70.3653L51.3508 70.5171L48.5004 72.206L48.2362 72.3577L45.2585 74.113L44.9852 74.2838L41.8889 76.1054L41.6067 76.2762L38.3738 78.1927L38.0733 78.3635L34.7038 80.3559L34.385 80.5456L30.8699 82.6234L30.5421 82.8227L26.8538 84.9953L26.5169 85.2041L22.6556 87.4811L22.2914 87.6993L18.248 90.0808L17.8746 90.3085L13.6309 92.8132L13.2303 93.0504L8.7771 95.688L8.35823 95.9346L3.66827 98.7051L3.23117 98.9612L-1.70468 101.883L-2.16913 102.159L-7.37813 105.242L-7.86992 105.527L-13.3703 108.781L-13.8894 109.085L-19.7086 112.529L-20.2641 112.851L-26.4293 116.494L-27.0121 116.846L-33.5598 120.716L-34.1791 121.077L-41.1456 125.195L-41.8014 125.584L-49.2232 129.976L-49.9244 130.384L-57.8564 135.071L-58.6031 135.517L-67.0905 140.536L-67.8919 141.011L-76.9894 146.381L-77.8546 146.903L-87.6352 152.68L-88.5641 153.231L-99.1278 159.474L-100.129 160.062L-111.549 166.817L-112.633 167.462L-125.018 174.777L-126.211 175.479L-139.689 183.459L-140.982 184.218L-155.735 192.937L-157.146 193.772L-173.338 203.345L-174.895 204.265L-192.726 214.806L-194.465 215.831L-214.227 227.519L-215.192 228.089H-213.243L-212.287 227.519L-192.617 215.831L-190.887 214.806L-173.138 204.265L-171.589 203.345L-155.471 193.772L-154.068 192.937L-139.379 184.218L-138.095 183.459L-124.681 175.479L-123.488 174.777L-111.167 167.462L-110.083 166.817L-98.718 160.062L-97.7162 159.474L-87.2072 153.231L-86.2874 152.68L-76.5523 146.903L-75.6781 146.381L-66.6261 141.011L-65.8248 140.536L-57.3829 135.517L-56.636 135.071L-48.7498 130.384L-48.0485 129.976L-40.663 125.584L-40.0073 125.195L-33.0771 121.077L-32.4579 120.716L-25.9375 116.846L-25.3638 116.494L-19.2168 112.851L-18.6704 112.529L-12.8786 109.085L-12.3594 108.781L-6.88632 105.527L-6.39464 105.242L-1.21289 102.159L-0.748444 101.883L4.16917 98.9612L4.60628 98.7051L9.26889 95.9346L9.68776 95.688L14.1227 93.0504L14.5143 92.8132L18.7399 90.3085L19.1131 90.0808L23.1383 87.6993L23.5026 87.4811L27.3365 85.2041L27.6825 84.9953L31.3434 82.8227L31.6713 82.6234L35.1773 80.5456L35.496 80.3559L38.8473 78.3635L39.1478 78.1927L42.3625 76.2762L42.6448 76.1054L45.7229 74.2838L46.0052 74.113L48.9557 72.3577L49.2198 72.206L52.0611 70.5171L52.3161 70.3653L55.0481 68.7429L55.2939 68.6006L57.9166 67.0447L58.1534 66.9023L60.676 65.4033L60.9037 65.2705L63.3352 63.8188L63.5537 63.6955L65.9032 62.3008L66.1126 62.1775L68.3712 60.8302L68.5806 60.7069L70.7571 59.4165L70.9574 59.2932L73.0701 58.0408L73.2614 57.927L75.2922 56.722L75.4834 56.6082L77.4505 55.4412L77.5415 55.3843Z'
                      fill='white'
                    />
                    <path
                      d='M100.864 55.3843H100.263L100.19 55.4412L98.5689 56.6082L98.4233 56.722L96.7476 57.927L96.5928 58.0408L94.8534 59.2932L94.6895 59.4165L92.8955 60.7069L92.7316 60.8302L90.8738 62.1775L90.7007 62.3008L88.7701 63.6955L88.588 63.8188L86.5846 65.2705L86.4024 65.4033L84.3261 66.9023L84.1257 67.0447L81.9675 68.6006L81.7672 68.7429L79.5269 70.3653L79.3174 70.5171L76.977 72.206L76.7676 72.3577L74.3361 74.113L74.1084 74.2838L71.5767 76.1054L71.34 76.2762L68.6991 78.1927L68.4441 78.3635L65.6848 80.3559L65.4297 80.5456L62.5521 82.6234L62.2789 82.8227L59.2646 84.9953L58.9823 85.2041L55.8223 87.4811L55.5308 87.6993L52.2251 90.0808L51.9155 90.3085L48.4368 92.8132L48.1089 93.0504L44.4663 95.688L44.1202 95.9346L40.2862 98.7051L39.922 98.9612L35.8786 101.883L35.5052 102.159L31.2343 105.242L30.8335 105.527L26.3349 108.781L25.9069 109.085L21.144 112.529L20.6978 112.851L15.6437 116.494L15.1701 116.846L9.80626 120.716L9.29634 121.077L3.60468 125.195L3.06729 125.584L-3.0159 129.976L-3.58961 130.384L-10.0736 135.071L-10.6929 135.517L-17.6321 140.536L-18.2969 141.011L-25.7371 146.381L-26.4564 146.903L-34.4612 152.68L-35.2171 153.231L-43.8594 159.474L-44.6789 160.062L-54.0315 166.817L-54.9239 167.462L-65.0596 174.777L-66.0341 175.479L-77.0714 183.459L-78.1277 184.218L-90.2031 192.937L-91.3597 193.772L-104.61 203.345L-105.885 204.265L-120.483 214.806L-121.903 215.831L-138.086 227.519L-138.869 228.089H-136.929L-136.146 227.519L-120.055 215.831L-118.643 214.806L-104.127 204.265L-102.861 203.345L-89.6841 193.772L-88.5275 192.937L-76.525 184.218L-75.4777 183.459L-64.5041 175.479L-63.5298 174.777L-53.4486 167.462L-52.5653 166.817L-43.2674 160.062L-42.4569 159.474L-33.8602 153.231L-33.1044 152.68L-25.1451 146.903L-24.4348 146.381L-17.0311 141.011L-16.3754 140.536L-9.4726 135.517L-8.86241 135.071L-2.40582 130.384L-1.8412 129.976L4.20563 125.584L4.74301 125.195L10.4073 121.077L10.9081 120.716L16.2446 116.846L16.7182 116.494L21.736 112.851L22.1822 112.529L26.9268 109.085L27.3457 108.781L31.8262 105.527L32.2177 105.242L36.4615 102.159L36.844 101.883L40.86 98.9612L41.2151 98.7051L45.0309 95.9346L45.377 95.688L49.0014 93.0504L49.3292 92.8132L52.7807 90.3085L53.0903 90.0808L56.3778 87.6993L56.6691 87.4811L59.811 85.2041L60.0932 84.9953L63.0894 82.8227L63.3535 82.6234L66.222 80.5456L66.477 80.3559L69.2181 78.3635L69.464 78.1927L72.0959 76.2762L72.3327 76.1054L74.8461 74.2838L75.0738 74.113L77.487 72.3577L77.7056 72.206L80.0278 70.5171L80.2372 70.3653L82.4684 68.7429L82.6687 68.6006L84.8087 67.0447L85.0091 66.9023L87.0672 65.4033L87.2585 65.2705L89.2437 63.8188L89.4259 63.6955L91.3474 62.3008L91.5204 62.1775L93.369 60.8302L93.533 60.7069L95.3179 59.4165L95.4817 59.2932L97.2029 58.0408L97.3578 57.927L99.0242 56.722L99.1791 56.6082L100.791 55.4412L100.864 55.3843Z'
                      fill='white'
                    />
                    <path
                      d='M124.177 55.3843H123.585L123.521 55.4412L122.265 56.6082L122.146 56.722L120.844 57.927L120.716 58.0408L119.369 59.2932L119.241 59.4165L117.848 60.7069L117.72 60.8302L116.272 62.1775L116.136 62.3008L114.633 63.6955L114.487 63.8188L112.93 65.2705L112.784 65.4033L111.173 66.9023L111.018 67.0447L109.342 68.6006L109.187 68.7429L107.439 70.3653L107.275 70.5171L105.454 72.206L105.29 72.3577L103.396 74.113L103.222 74.2838L101.246 76.1054L101.064 76.2762L99.006 78.1927L98.8148 78.3635L96.6657 80.3559L96.4654 80.5456L94.2251 82.6234L94.0156 82.8227L91.6661 84.9953L91.4476 85.2041L88.9887 87.4811L88.761 87.6993L86.1839 90.0808L85.938 90.3085L83.2425 92.8132L82.9874 93.0504L80.1462 95.688L79.882 95.9346L76.8951 98.7051L76.6128 98.9612L73.4619 101.883L73.1704 102.159L69.8466 105.242L69.5369 105.527L66.0308 108.781L65.703 109.085L61.9875 112.529L61.6415 112.851L57.7073 116.494L57.343 116.846L53.1631 120.716L52.7716 121.077L48.3366 125.195L47.9177 125.584L43.1822 129.976L42.736 130.384L37.6909 135.071L37.2082 135.517L31.808 140.536L31.2889 141.011L25.4971 146.381L24.9416 146.903L18.7126 152.68L18.1207 153.231L11.3908 159.474L10.7534 160.062L3.4772 166.817L2.77596 167.462L-5.11044 174.777L-5.86625 175.479L-14.463 183.459L-15.2826 184.218L-24.6807 192.937L-25.5822 193.772L-35.9 203.345L-36.8927 204.265L-48.2578 214.806L-49.3597 215.831L-61.9543 227.519L-62.5735 228.089H-60.6246L-60.0146 227.519L-47.511 215.831L-46.4183 214.806L-35.1351 204.265L-34.1516 203.345L-23.9066 193.772L-23.0142 192.937L-13.6798 184.218L-12.8693 183.459L-4.3364 175.479L-3.58047 174.777L4.25124 167.462L4.93424 166.817L12.1649 160.062L12.7933 159.474L19.4776 153.231L20.0604 152.68L26.253 146.903L26.7994 146.381L32.5547 141.011L33.0648 140.536L38.4286 135.517L38.902 135.071L43.9198 130.384L44.366 129.976L49.056 125.584L49.475 125.195L53.8826 121.077L54.2741 120.716L58.4177 116.846L58.782 116.494L62.6887 112.851L63.0347 112.529L66.7138 109.085L67.0417 108.781L70.5205 105.527L70.8301 105.242L74.1267 102.159L74.418 101.883L77.5417 98.9612L77.824 98.7051L80.7927 95.9346L81.0568 95.688L83.8708 93.0504L84.1258 92.8132L86.8123 90.3085L87.049 90.0808L89.608 87.6993L89.8357 87.4811L92.2763 85.2041L92.4949 84.9953L94.817 82.8227L95.0264 82.6234L97.2576 80.5456L97.458 80.3559L99.5889 78.3635L99.7802 78.1927L101.82 76.2762L102.002 76.1054L103.96 74.2838L104.133 74.113L106.018 72.3577L106.182 72.206L107.985 70.5171L108.149 70.3653L109.879 68.7429L110.034 68.6006L111.701 67.0447L111.856 66.9023L113.458 65.4033L113.604 65.2705L115.152 63.8188L115.289 63.6955L116.782 62.3008L116.919 62.1775L118.349 60.8302L118.485 60.7069L119.869 59.4165L119.997 59.2932L121.336 58.0408L121.454 57.927L122.747 56.722L122.866 56.6082L124.122 55.4412L124.177 55.3843Z'
                      fill='white'
                    />
                    <path
                      d='M147.5 55.3848H146.908L146.862 55.4417L145.961 56.6087L145.879 56.7225L144.941 57.9275L144.859 58.0413L143.893 59.2937L143.802 59.417L142.801 60.7073L142.71 60.8307L141.671 62.178L141.58 62.3013L140.506 63.696L140.406 63.8193L139.285 65.2709L139.185 65.4038L138.029 66.9028L137.919 67.0451L136.717 68.6011L136.608 68.7434L135.36 70.3658L135.242 70.5176L133.94 72.2064L133.821 72.3582L132.465 74.1135L132.337 74.2843L130.926 76.1059L130.798 76.2766L129.323 78.1932L129.186 78.3639L127.656 80.3564L127.511 80.5461L125.908 82.6239L125.753 82.8232L124.077 84.9958L123.923 85.2046L122.165 87.4816L121.992 87.6998L120.152 90.0812L119.979 90.3089L118.049 92.8137L117.867 93.0509L115.836 95.6885L115.645 95.9351L113.504 98.7056L113.304 98.9617L111.055 101.884L110.845 102.159L108.468 105.243L108.25 105.527L105.736 108.781L105.5 109.085L102.85 112.529L102.595 112.852L99.7899 116.495L99.5258 116.846L96.5387 120.717L96.2565 121.078L93.0783 125.195L92.7777 125.584L89.3991 129.977L89.0804 130.385L85.465 135.072L85.1189 135.518L81.2577 140.537L80.8844 141.011L76.7409 146.381L76.3492 146.903L71.887 152.681L71.4681 153.231L66.6507 159.474L66.1954 160.062L60.9863 166.818L60.4946 167.463L54.8484 174.778L54.3111 175.48L48.1641 183.459L47.5722 184.218L40.8514 192.937L40.2049 193.772L32.8285 203.345L32.1182 204.266L23.9859 214.806L23.1936 215.831L14.1872 227.52L13.75 228.089H15.6897L16.1269 227.52L25.0423 215.831L25.8254 214.806L33.8758 204.266L34.5769 203.345L41.8805 193.772L42.518 192.937L49.175 184.218L49.7578 183.459L55.8411 175.48L56.3784 174.778L61.9608 167.463L62.4525 166.818L67.6068 160.062L68.0622 159.474L72.8249 153.231L73.2439 152.681L77.6515 146.903L78.0523 146.381L82.1503 141.011L82.5145 140.537L86.3393 135.518L86.6854 135.072L90.2551 130.385L90.5739 129.977L93.9251 125.584L94.2166 125.195L97.3584 121.078L97.6406 120.717L100.591 116.846L100.855 116.495L103.642 112.852L103.888 112.529L106.52 109.085L106.747 108.781L109.233 105.527L109.452 105.243L111.802 102.159L112.011 101.884L114.242 98.9617L114.442 98.7056L116.555 95.9351L116.746 95.6885L118.75 93.0509L118.932 92.8137L120.844 90.3089L121.017 90.0812L122.839 87.6998L123.003 87.4816L124.742 85.2046L124.897 84.9958L126.563 82.8232L126.709 82.6239L128.303 80.5461L128.439 80.3564L129.96 78.3639L130.097 78.1932L131.554 76.2766L131.681 76.1059L133.084 74.2843L133.202 74.1135L134.541 72.3582L134.668 72.2064L135.952 70.5176L136.071 70.3658L137.3 68.7434L137.419 68.6011L138.602 67.0451L138.712 66.9028L139.859 65.4038L139.959 65.2709L141.061 63.8193L141.161 63.696L142.227 62.3013L142.318 62.178L143.347 60.8307L143.438 60.7073L144.431 59.417L144.513 59.2937L145.469 58.0413L145.56 57.9275L146.48 56.7225L146.562 56.6087L147.463 55.4417L147.5 55.3848Z'
                      fill='white'
                    />
                    <path
                      d='M170.822 55.3848H170.221L170.193 55.4417L169.656 56.6087L169.601 56.7225L169.046 57.9275L168.991 58.0413L168.408 59.2937L168.354 59.417L167.753 60.7073L167.698 60.8307L167.07 62.178L167.015 62.3013L166.368 63.696L166.305 63.8193L165.64 65.2709L165.576 65.4038L164.875 66.9028L164.811 67.0451L164.092 68.6011L164.019 68.7434L163.272 70.3658L163.199 70.5176L162.416 72.2064L162.343 72.3582L161.524 74.1135L161.451 74.2843L160.604 76.1059L160.522 76.2766L159.639 78.1932L159.557 78.3639L158.628 80.3564L158.546 80.5461L157.581 82.6239L157.489 82.8232L156.479 84.9958L156.378 85.2046L155.322 87.4816L155.222 87.6998L154.111 90.0812L154.011 90.3089L152.845 92.8137L152.736 93.0509L151.515 95.6885L151.397 95.9351L150.113 98.7056L149.995 98.9617L148.638 101.884L148.51 102.159L147.081 105.243L146.944 105.527L145.432 108.781L145.296 109.085L143.693 112.529L143.547 112.852L141.853 116.495L141.689 116.846L139.895 120.717L139.722 121.078L137.819 125.195L137.637 125.584L135.597 129.977L135.406 130.385L133.229 135.072L133.02 135.518L130.698 140.537L130.47 141.011L127.975 146.381L127.738 146.903L125.052 152.681L124.797 153.231L121.901 159.474L121.627 160.062L118.495 166.818L118.194 167.463L114.797 174.778L114.47 175.48L110.772 183.459L110.417 184.218L106.365 192.937L105.982 193.772L101.538 203.345L101.11 204.266L96.2198 214.806L95.7371 215.831L90.3187 227.52L90.0546 228.089H92.0125L92.2675 227.52L97.604 215.831L98.0685 214.806L102.886 204.266L103.305 203.345L107.667 193.772L108.049 192.937L112.029 184.218L112.375 183.459L116.018 175.48L116.336 174.778L119.679 167.463L119.97 166.818L123.048 160.062L123.321 159.474L126.172 153.231L126.427 152.681L129.058 146.903L129.295 146.381L131.745 141.011L131.963 140.537L134.258 135.518L134.459 135.072L136.599 130.385L136.781 129.977L138.784 125.584L138.966 125.195L140.842 121.078L141.006 120.717L142.773 116.846L142.937 116.495L144.594 112.852L144.749 112.529L146.316 109.085L146.452 108.781L147.937 105.527L148.073 105.243L149.476 102.159L149.603 101.884L150.933 98.9617L151.051 98.7056L152.317 95.9351L152.435 95.6885L153.637 93.0509L153.738 92.8137L154.885 90.3089L154.985 90.0812L156.078 87.6998L156.178 87.4816L157.216 85.2046L157.307 84.9958L158.3 82.8232L158.391 82.6239L159.338 80.5461L159.429 80.3564L160.331 78.3639L160.413 78.1932L161.287 76.2766L161.369 76.1059L162.198 74.2843L162.27 74.1135L163.072 72.3582L163.145 72.2064L163.919 70.5176L163.983 70.3658L164.729 68.7434L164.793 68.6011L165.503 67.0451L165.567 66.9028L166.25 65.4038L166.314 65.2709L166.969 63.8193L167.033 63.696L167.671 62.3013L167.725 62.178L168.335 60.8307L168.39 60.7073L168.982 59.417L169.037 59.2937L169.61 58.0413L169.665 57.9275L170.211 56.7225L170.266 56.6087L170.794 55.4417L170.822 55.3848Z'
                      fill='white'
                    />
                    <path
                      d='M194.134 55.3848H193.542L193.533 55.4417L193.351 56.6087L193.333 56.7225L193.141 57.9275L193.123 58.0413L192.932 59.2937L192.914 59.417L192.704 60.7073L192.686 60.8307L192.476 62.178L192.458 62.3013L192.24 63.696L192.212 63.8193L191.985 65.2709L191.967 65.4038L191.73 66.9028L191.711 67.0451L191.466 68.6011L191.438 68.7434L191.183 70.3658L191.165 70.5176L190.901 72.2064L190.874 72.3582L190.601 74.1135L190.573 74.2843L190.282 76.1059L190.254 76.2766L189.954 78.1932L189.927 78.3639L189.617 80.3564L189.581 80.5461L189.253 82.6239L189.225 82.8232L188.888 84.9958L188.852 85.2046L188.497 87.4816L188.46 87.6998L188.087 90.0812L188.051 90.3089L187.65 92.8137L187.613 93.0509L187.204 95.6885L187.167 95.9351L186.73 98.7056L186.685 98.9617L186.229 101.884L186.184 102.159L185.701 105.243L185.656 105.527L185.146 108.781L185.091 109.085L184.554 112.529L184.499 112.852L183.925 116.495L183.871 116.846L183.26 120.717L183.206 121.078L182.559 125.195L182.496 125.584L181.803 129.977L181.74 130.385L181.002 135.072L180.938 135.518L180.146 140.537L180.073 141.011L179.226 146.381L179.144 146.903L178.234 152.681L178.152 153.231L177.168 159.474L177.068 160.062L176.012 166.818L175.911 167.463L174.755 174.778L174.646 175.48L173.389 183.459L173.27 184.218L171.904 192.937L171.768 193.772L170.265 203.345L170.12 204.266L168.462 214.806L168.298 215.831L166.459 227.52L166.368 228.089H168.317L168.398 227.52L170.147 215.831L170.302 214.806L171.877 204.266L172.014 203.345L173.444 193.772L173.571 192.937L174.873 184.218L174.983 183.459L176.176 175.48L176.285 174.778L177.378 167.463L177.478 166.818L178.489 160.062L178.571 159.474L179.509 153.231L179.591 152.681L180.456 146.903L180.528 146.381L181.33 141.011L181.403 140.537L182.159 135.518L182.222 135.072L182.924 130.385L182.987 129.977L183.643 125.584L183.698 125.195L184.317 121.078L184.372 120.717L184.945 116.846L185 116.495L185.546 112.852L185.592 112.529L186.111 109.085L186.156 108.781L186.639 105.527L186.685 105.243L187.14 102.159L187.186 101.884L187.623 98.9617L187.659 98.7056L188.078 95.9351L188.114 95.6885L188.506 93.0509L188.542 92.8137L188.916 90.3089L188.952 90.0812L189.307 87.6998L189.335 87.4816L189.681 85.2046L189.708 84.9958L190.036 82.8232L190.063 82.6239L190.373 80.5461L190.4 80.3564L190.701 78.3639L190.728 78.1932L191.01 76.2766L191.038 76.1059L191.311 74.2843L191.338 74.1135L191.602 72.3582L191.62 72.2064L191.875 70.5176L191.894 70.3658L192.139 68.7434L192.158 68.6011L192.394 67.0451L192.413 66.9028L192.64 65.4038L192.659 65.2709L192.877 63.8193L192.895 63.696L193.105 62.3013L193.123 62.178L193.323 60.8307L193.342 60.7073L193.533 59.417L193.551 59.2937L193.742 58.0413L193.76 57.9275L193.934 56.7225L193.952 56.6087L194.125 55.4417L194.134 55.3848Z'
                      fill='white'
                    />
                    <path
                      d='M217.457 55.3848H216.856L216.865 55.4417L217.047 56.6087L217.056 56.7225L217.238 57.9275L217.257 58.0413L217.448 59.2937L217.466 59.417L217.657 60.7073L217.676 60.8307L217.876 62.178L217.894 62.3013L218.104 63.696L218.122 63.8193L218.34 65.2709L218.359 65.4038L218.577 66.9028L218.604 67.0451L218.832 68.6011L218.859 68.7434L219.096 70.3658L219.124 70.5176L219.369 72.2064L219.397 72.3582L219.661 74.1135L219.688 74.2843L219.961 76.1059L219.98 76.2766L220.271 78.1932L220.298 78.3639L220.59 80.3564L220.617 80.5461L220.936 82.6239L220.963 82.8232L221.282 84.9958L221.318 85.2046L221.655 87.4816L221.692 87.6998L222.047 90.0812L222.083 90.3089L222.457 92.8137L222.493 93.0509L222.885 95.6885L222.921 95.9351L223.331 98.7056L223.376 98.9617L223.813 101.884L223.85 102.159L224.314 105.243L224.351 105.527L224.843 108.781L224.888 109.085L225.398 112.529L225.453 112.852L225.99 116.495L226.045 116.846L226.627 120.717L226.682 121.078L227.292 125.195L227.356 125.584L228.012 129.977L228.066 130.385L228.768 135.072L228.84 135.518L229.587 140.537L229.66 141.011L230.461 146.381L230.534 146.903L231.399 152.681L231.481 153.231L232.419 159.474L232.501 160.062L233.512 166.818L233.612 167.463L234.705 174.778L234.814 175.48L235.998 183.459L236.117 184.218L237.419 192.937L237.546 193.772L238.976 203.345L239.113 204.266L240.688 214.806L240.843 215.831L242.591 227.52L242.673 228.089H244.631L244.54 227.52L242.701 215.831L242.546 214.806L240.888 204.266L240.743 203.345L239.231 193.772L239.104 192.937L237.728 184.218L237.61 183.459L236.353 175.48L236.244 174.778L235.097 167.463L234.996 166.818L233.931 160.062L233.84 159.474L232.856 153.231L232.765 152.681L231.855 146.903L231.782 146.381L230.935 141.011L230.853 140.537L230.07 135.518L229.997 135.072L229.259 130.385L229.196 129.977L228.503 125.584L228.44 125.195L227.793 121.078L227.738 120.717L227.128 116.846L227.074 116.495L226.5 112.852L226.454 112.529L225.908 109.085L225.862 108.781L225.353 105.527L225.307 105.243L224.815 102.159L224.779 101.884L224.314 98.9617L224.278 98.7056L223.841 95.9351L223.804 95.6885L223.385 93.0509L223.349 92.8137L222.957 90.3089L222.921 90.0812L222.539 87.6998L222.511 87.4816L222.147 85.2046L222.12 84.9958L221.774 82.8232L221.746 82.6239L221.418 80.5461L221.391 80.3564L221.072 78.3639L221.045 78.1932L220.745 76.2766L220.717 76.1059L220.435 74.2843L220.408 74.1135L220.134 72.3582L220.107 72.2064L219.843 70.5176L219.816 70.3658L219.561 68.7434L219.542 68.6011L219.297 67.0451L219.269 66.9028L219.032 65.4038L219.014 65.2709L218.787 63.8193L218.768 63.696L218.55 62.3013L218.532 62.178L218.313 60.8307L218.295 60.7073L218.094 59.417L218.076 59.2937L217.876 58.0413L217.858 57.9275L217.666 56.7225L217.648 56.6087L217.466 55.4417L217.457 55.3848Z'
                      fill='white'
                    />
                    <path
                      d='M240.778 55.3848H240.177L240.205 55.4417L240.742 56.6087L240.787 56.7225L241.343 57.9275L241.398 58.0413L241.962 59.2937L242.017 59.417L242.609 60.7073L242.663 60.8307L243.274 62.178L243.337 62.3013L243.975 63.696L244.029 63.8193L244.694 65.2709L244.749 65.4038L245.432 66.9028L245.496 67.0451L246.215 68.6011L246.279 68.7434L247.016 70.3658L247.089 70.5176L247.854 72.2064L247.927 72.3582L248.728 74.1135L248.801 74.2843L249.639 76.1059L249.712 76.2766L250.586 78.1932L250.668 78.3639L251.579 80.3564L251.661 80.5461L252.608 82.6239L252.699 82.8232L253.692 84.9958L253.783 85.2046L254.83 87.4816L254.921 87.6998L256.014 90.0812L256.114 90.3089L257.261 92.8137L257.371 93.0509L258.573 95.6885L258.682 95.9351L259.948 98.7056L260.066 98.9617L261.396 101.884L261.523 102.159L262.926 105.243L263.062 105.527L264.547 108.781L264.683 109.085L266.259 112.529L266.404 112.852L268.071 116.495L268.226 116.846L269.992 120.717L270.156 121.078L272.041 125.195L272.215 125.584L274.218 129.977L274.409 130.385L276.549 135.072L276.75 135.518L279.035 140.537L279.254 141.011L281.704 146.381L281.94 146.903L284.581 152.681L284.827 153.231L287.678 159.474L287.951 160.062L291.029 166.818L291.32 167.463L294.663 174.778L294.99 175.48L298.624 183.459L298.97 184.218L302.95 192.937L303.332 193.772L307.703 203.345L308.122 204.266L312.93 214.806L313.395 215.831L318.731 227.52L318.986 228.089H320.935L320.671 227.52L315.244 215.831L314.77 214.806L309.88 204.266L309.452 203.345L305.008 193.772L304.616 192.937L300.573 184.218L300.218 183.459L296.52 175.48L296.192 174.778L292.796 167.463L292.495 166.818L289.362 160.062L289.089 159.474L286.193 153.231L285.938 152.681L283.252 146.903L283.015 146.381L280.52 141.011L280.292 140.537L277.97 135.518L277.76 135.072L275.584 130.385L275.393 129.977L273.362 125.584L273.18 125.195L271.267 121.078L271.094 120.717L269.3 116.846L269.136 116.495L267.452 112.852L267.297 112.529L265.703 109.085L265.558 108.781L264.046 105.527L263.909 105.243L262.489 102.159L262.361 101.884L261.004 98.9617L260.877 98.7056L259.593 95.9351L259.483 95.6885L258.254 93.0509L258.145 92.8137L256.988 90.3089L256.879 90.0812L255.768 87.6998L255.668 87.4816L254.611 85.2046L254.52 84.9958L253.509 82.8232L253.418 82.6239L252.453 80.5461L252.362 80.3564L251.442 78.3639L251.36 78.1932L250.468 76.2766L250.395 76.1059L249.548 74.2843L249.466 74.1135L248.656 72.3582L248.583 72.2064L247.8 70.5176L247.727 70.3658L246.971 68.7434L246.907 68.6011L246.188 67.0451L246.124 66.9028L245.423 65.4038L245.359 65.2709L244.694 63.8193L244.63 63.696L243.984 62.3013L243.929 62.178L243.301 60.8307L243.246 60.7073L242.645 59.417L242.591 59.2937L242.008 58.0413L241.953 57.9275L241.398 56.7225L241.343 56.6087L240.797 55.4417L240.778 55.3848Z'
                      fill='white'
                    />
                    <path
                      d='M264.101 55.3848H263.5L263.545 55.4417L264.438 56.6087L264.52 56.7225L265.449 57.9275L265.531 58.0413L266.487 59.2937L266.578 59.417L267.561 60.7073L267.662 60.8307L268.682 62.178L268.782 62.3013L269.838 63.696L269.938 63.8193L271.04 65.2709L271.149 65.4038L272.288 66.9028L272.397 67.0451L273.59 68.6011L273.699 68.7434L274.938 70.3658L275.047 70.5176L276.34 72.2064L276.459 72.3582L277.797 74.1135L277.925 74.2843L279.318 76.1059L279.446 76.2766L280.903 78.1932L281.039 78.3639L282.56 80.3564L282.706 80.5461L284.29 82.6239L284.445 82.8232L286.103 84.9958L286.257 85.2046L287.997 87.4816L288.161 87.6998L289.982 90.0812L290.155 90.3089L292.067 92.8137L292.25 93.0509L294.262 95.6885L294.444 95.9351L296.566 98.7056L296.766 98.9617L298.989 101.884L299.198 102.159L301.547 105.243L301.775 105.527L304.252 108.781L304.489 109.085L307.112 112.529L307.357 112.852L310.144 116.495L310.408 116.846L313.359 120.717L313.641 121.078L316.783 125.195L317.083 125.584L320.426 129.977L320.744 130.385L324.323 135.072L324.66 135.518L328.485 140.537L328.849 141.011L332.956 146.381L333.348 146.903L337.756 152.681L338.184 153.231L342.946 159.474L343.393 160.062L348.547 166.818L349.039 167.463L354.621 174.778L355.167 175.48L361.251 183.459L361.834 184.218L368.481 192.937L369.119 193.772L376.422 203.345L377.124 204.266L385.174 214.806L385.957 215.831L394.873 227.52L395.31 228.089H397.249L396.812 227.52L387.806 215.831L387.013 214.806L378.881 204.266L378.18 203.345L370.795 193.772L370.148 192.937L363.427 184.218L362.844 183.459L356.697 175.48L356.151 174.778L350.505 167.463L350.013 166.818L344.804 160.062L344.349 159.474L339.54 153.231L339.112 152.681L334.659 146.903L334.259 146.381L330.115 141.011L329.751 140.537L325.88 135.518L325.534 135.072L321.928 130.385L321.609 129.977L318.222 125.584L317.921 125.195L314.752 121.078L314.47 120.717L311.483 116.846L311.219 116.495L308.405 112.852L308.15 112.529L305.5 109.085L305.263 108.781L302.759 105.527L302.531 105.243L300.163 102.159L299.945 101.884L297.695 98.9617L297.495 98.7056L295.355 95.9351L295.164 95.6885L293.142 93.0509L292.96 92.8137L291.02 90.3089L290.847 90.0812L289.008 87.6998L288.844 87.4816L287.086 85.2046L286.931 84.9958L285.246 82.8232L285.101 82.6239L283.498 80.5461L283.352 80.3564L281.813 78.3639L281.677 78.1932L280.201 76.2766L280.074 76.1059L278.662 74.2843L278.535 74.1135L277.187 72.3582L277.06 72.2064L275.767 70.5176L275.648 70.3658L274.401 68.7434L274.282 68.6011L273.08 67.0451L272.98 66.9028L271.823 65.4038L271.714 65.2709L270.603 63.8193L270.503 63.696L269.428 62.3013L269.328 62.178L268.29 60.8307L268.199 60.7073L267.197 59.417L267.115 59.2937L266.141 58.0413L266.059 57.9275L265.121 56.7225L265.039 56.6087L264.137 55.4417L264.101 55.3848Z'
                      fill='white'
                    />
                    <path
                      d='M287.414 55.3848H286.822L286.877 55.4417L288.125 56.6087L288.243 56.7225L289.545 57.9275L289.664 58.0413L291.002 59.2937L291.13 59.417L292.514 60.7073L292.641 60.8307L294.08 62.178L294.217 62.3013L295.71 63.696L295.847 63.8193L297.395 65.2709L297.532 65.4038L299.144 66.9028L299.289 67.0451L300.956 68.6011L301.111 68.7434L302.85 70.3658L303.014 70.5176L304.817 72.2064L304.981 72.3582L306.857 74.1135L307.039 74.2843L308.988 76.1059L309.179 76.2766L311.219 78.1932L311.41 78.3639L313.541 80.3564L313.742 80.5461L315.964 82.6239L316.173 82.8232L318.504 84.9958L318.723 85.2046L321.164 87.4816L321.391 87.6998L323.95 90.0812L324.187 90.3089L326.873 92.8137L327.119 93.0509L329.942 95.6885L330.206 95.9351L333.166 98.7056L333.448 98.9617L336.572 101.884L336.863 102.159L340.16 105.243L340.47 105.527L343.948 108.781L344.276 109.085L347.964 112.529L348.311 112.852L352.208 116.495L352.582 116.846L356.725 120.717L357.117 121.078L361.515 125.195L361.934 125.584L366.633 129.977L367.07 130.385L372.088 135.072L372.562 135.518L377.925 140.537L378.435 141.011L384.191 146.381L384.737 146.903L390.93 152.681L391.513 153.231L398.197 159.474L398.825 160.062L406.056 166.818L406.739 167.463L414.571 174.778L415.327 175.48L423.859 183.459L424.67 184.218L434.004 192.937L434.897 193.772L445.133 203.345L446.116 204.266L457.399 214.806L458.501 215.831L471.005 227.52L471.615 228.089H473.555L472.944 227.52L460.35 215.831L459.239 214.806L447.874 204.266L446.89 203.345L436.572 193.772L435.671 192.937L426.273 184.218L425.453 183.459L416.856 175.48L416.101 174.778L408.214 167.463L407.513 166.818L400.237 160.062L399.599 159.474L392.879 153.231L392.278 152.681L386.049 146.903L385.493 146.381L379.701 141.011L379.191 140.537L373.782 135.518L373.308 135.072L368.254 130.385L367.808 129.977L363.072 125.584L362.654 125.195L358.219 121.078L357.827 120.717L353.656 116.846L353.283 116.495L349.349 112.852L349.003 112.529L345.296 109.085L344.959 108.781L341.453 105.527L341.144 105.243L337.829 102.159L337.528 101.884L334.386 98.9617L334.104 98.7056L331.117 95.9351L330.844 95.6885L328.012 93.0509L327.757 92.8137L325.052 90.3089L324.815 90.0812L322.238 87.6998L322.001 87.4816L319.552 85.2046L319.324 84.9958L316.984 82.8232L316.774 82.6239L314.534 80.5461L314.324 80.3564L312.184 78.3639L311.993 78.1932L309.935 76.2766L309.744 76.1059L307.777 74.2843L307.604 74.1135L305.71 72.3582L305.537 72.2064L303.724 70.5176L303.56 70.3658L301.812 68.7434L301.657 68.6011L299.972 67.0451L299.827 66.9028L298.206 65.4038L298.06 65.2709L296.503 63.8193L296.366 63.696L294.864 62.3013L294.727 62.178L293.279 60.8307L293.151 60.7073L291.749 59.417L291.631 59.2937L290.274 58.0413L290.155 57.9275L288.853 56.7225L288.735 56.6087L287.469 55.4417L287.414 55.3848Z'
                      fill='white'
                    />
                    <path
                      d='M310.736 55.3848H310.144L310.217 55.4417L311.829 56.6087L311.974 56.7225L313.641 57.9275L313.796 58.0413L315.526 59.2937L315.681 59.417L317.466 60.7073L317.639 60.8307L319.487 62.178L319.66 62.3013L321.573 63.696L321.755 63.8193L323.749 65.2709L323.932 65.4038L325.999 66.9028L326.19 67.0451L328.33 68.6011L328.53 68.7434L330.762 70.3658L330.971 70.5176L333.293 72.2064L333.512 72.3582L335.934 74.1135L336.153 74.2843L338.675 76.1059L338.912 76.2766L341.535 78.1932L341.781 78.3639L344.522 80.3564L344.777 80.5461L347.645 82.6239L347.918 82.8232L350.914 84.9958L351.188 85.2046L354.329 87.4816L354.621 87.6998L357.918 90.0812L358.227 90.3089L361.679 92.8137L361.997 93.0509L365.631 95.6885L365.968 95.9351L369.784 98.7056L370.139 98.9617L374.164 101.884L374.537 102.159L378.781 105.243L379.182 105.527L383.653 108.781L384.081 109.085L388.817 112.529L389.263 112.852L394.29 116.495L394.763 116.846L400.09 120.717L400.591 121.078L406.265 125.195L406.793 125.584L412.84 129.977L413.414 130.385L419.861 135.072L420.471 135.518L427.383 140.537L428.03 141.011L435.434 146.381L436.144 146.903L444.103 152.681L444.868 153.231L453.456 159.474L454.275 160.062L463.564 166.818L464.456 167.463L474.529 174.778L475.503 175.48L486.476 183.459L487.533 184.218L499.535 192.937L500.683 193.772L513.86 203.345L515.126 204.266L529.651 214.806L531.063 215.831L547.145 227.52L547.928 228.089H549.877L549.085 227.52L532.902 215.831L531.482 214.806L516.883 204.266L515.609 203.345L502.358 193.772L501.202 192.937L489.126 184.218L488.07 183.459L477.033 175.48L476.058 174.778L465.923 167.463L465.03 166.818L455.687 160.062L454.867 159.474L446.225 153.231L445.46 152.681L437.455 146.903L436.745 146.381L429.296 141.011L428.64 140.537L421.692 135.518L421.081 135.072L414.588 130.385L414.015 129.977L407.941 125.584L407.403 125.195L401.702 121.078L401.192 120.717L395.838 116.846L395.355 116.495L390.31 112.852L389.855 112.529L385.092 109.085L384.664 108.781L380.165 105.527L379.764 105.243L375.503 102.159L375.12 101.884L371.077 98.9617L370.712 98.7056L366.879 95.9351L366.532 95.6885L362.89 93.0509L362.562 92.8137L359.092 90.3089L358.783 90.0812L355.468 87.6998L355.176 87.4816L352.016 85.2046L351.734 84.9958L348.72 82.8232L348.456 82.6239L345.569 80.5461L345.314 80.3564L342.555 78.3639L342.309 78.1932L339.668 76.2766L339.431 76.1059L336.899 74.2843L336.672 74.1135L334.24 72.3582L334.022 72.2064L331.69 70.5176L331.481 70.3658L329.232 68.7434L329.031 68.6011L326.873 67.0451L326.682 66.9028L324.605 65.4038L324.414 65.2709L322.411 63.8193L322.238 63.696L320.307 62.3013L320.134 62.178L318.276 60.8307L318.103 60.7073L316.309 59.417L316.145 59.2937L314.415 58.0413L314.26 57.9275L312.585 56.7225L312.43 56.6087L310.809 55.4417L310.736 55.3848Z'
                      fill='white'
                    />
                    <path
                      d='M334.048 55.3848H333.456L333.547 55.4417L335.514 56.6087L335.696 56.7225L337.736 57.9275L337.927 58.0413L340.04 59.2937L340.231 59.417L342.417 60.7073L342.617 60.8307L344.885 62.178L345.094 62.3013L347.444 63.696L347.662 63.8193L350.094 65.2709L350.321 65.4038L352.844 66.9028L353.081 67.0451L355.703 68.6011L355.949 68.7434L358.672 70.3658L358.927 70.5176L361.769 72.2064L362.033 72.3582L364.992 74.1135L365.265 74.2843L368.344 76.1059L368.635 76.2766L371.85 78.1932L372.15 78.3639L375.501 80.3564L375.811 80.5461L379.317 82.6239L379.645 82.8232L383.315 84.9958L383.652 85.2046L387.495 87.4816L387.85 87.6998L391.875 90.0812L392.258 90.3089L396.474 92.8137L396.875 93.0509L401.31 95.6885L401.719 95.9351L406.391 98.7056L406.828 98.9617L411.746 101.884L412.201 102.159L417.392 105.243L417.875 105.527L423.357 108.781L423.867 109.085L429.668 112.529L430.214 112.852L436.352 116.495L436.935 116.846L443.446 120.717L444.065 121.078L450.996 125.195L451.651 125.584L459.037 129.977L459.738 130.385L467.624 135.072L468.371 135.518L476.822 140.537L477.614 141.011L486.666 146.381L487.541 146.903L497.276 152.681L498.196 153.231L508.705 159.474L509.706 160.062L521.071 166.818L522.155 167.463L534.476 174.778L535.669 175.48L549.084 183.459L550.368 184.218L565.048 192.937L566.459 193.772L582.569 203.345L584.117 204.266L601.875 214.806L603.596 215.831L623.276 227.52L624.232 228.089H626.171L625.215 227.52L605.445 215.831L603.714 214.806L585.874 204.266L584.317 203.345L568.135 193.772L566.723 192.937L551.97 184.218L550.677 183.459L537.199 175.48L536.006 174.778L523.621 167.463L522.538 166.818L511.118 160.062L510.116 159.474L499.552 153.231L498.624 152.681L488.843 146.903L487.978 146.381L478.88 141.011L478.079 140.537L469.591 135.518L468.845 135.072L460.913 130.385L460.212 129.977L452.79 125.584L452.134 125.195L445.176 121.078L444.557 120.717L438 116.846L437.427 116.495L431.252 112.852L430.706 112.529L424.878 109.085L424.368 108.781L418.867 105.527L418.376 105.243L413.167 102.159L412.702 101.884L407.766 98.9617L407.32 98.7056L402.63 95.9351L402.211 95.6885L397.758 93.0509L397.366 92.8137L393.123 90.3089L392.74 90.0812L388.697 87.6998L388.342 87.4816L384.481 85.2046L384.135 84.9958L380.455 82.8232L380.128 82.6239L376.603 80.5461L376.294 80.3564L372.924 78.3639L372.615 78.1932L369.391 76.2766L369.099 76.1059L366.012 74.2843L365.73 74.1135L362.761 72.3582L362.497 72.2064L359.647 70.5176L359.392 70.3658L356.651 68.7434L356.405 68.6011L353.764 67.0451L353.527 66.9028L350.995 65.4038L350.759 65.2709L348.318 63.8193L348.099 63.696L345.741 62.3013L345.531 62.178L343.255 60.8307L343.054 60.7073L340.86 59.417L340.659 59.2937L338.547 58.0413L338.355 57.9275L336.306 56.7225L336.124 56.6087L334.139 55.4417L334.048 55.3848Z'
                      fill='white'
                    />
                    <path
                      d='M357.37 55.3848H356.778L356.888 55.4417L359.21 56.6087L359.429 56.7225L361.842 57.9275L362.069 58.0413L364.556 59.2937L364.792 59.417L367.369 60.7073L367.615 60.8307L370.284 62.178L370.539 62.3013L373.307 63.696L373.571 63.8193L376.449 65.2709L376.713 65.4038L379.7 66.9028L379.982 67.0451L383.078 68.6011L383.37 68.7434L386.594 70.3658L386.894 70.5176L390.255 72.2064L390.564 72.3582L394.061 74.1135L394.389 74.2843L398.023 76.1059L398.369 76.2766L402.166 78.1932L402.521 78.3639L406.483 80.3564L406.856 80.5461L411 82.6239L411.391 82.8232L415.717 84.9958L416.127 85.2046L420.662 87.4816L421.09 87.6998L425.843 90.0812L426.29 90.3089L431.289 92.8137L431.754 93.0509L436.99 95.6885L437.491 95.9351L443 98.7056L443.519 98.9617L449.339 101.884L449.885 102.159L456.014 105.243L456.587 105.527L463.062 108.781L463.672 109.085L470.521 112.529L471.167 112.852L478.425 116.495L479.108 116.846L486.822 120.717L487.55 121.078L495.737 125.195L496.511 125.584L505.254 129.977L506.073 130.385L515.407 135.072L516.291 135.518L526.272 140.537L527.219 141.011L537.919 146.381L538.939 146.903L550.45 152.681L551.543 153.231L563.964 159.474L565.148 160.062L578.589 166.818L579.874 167.463L594.435 174.778L595.847 175.48L611.71 183.459L613.231 184.218L630.579 192.937L632.246 193.772L651.297 203.345L653.128 204.266L674.118 214.806L676.158 215.831L699.417 227.52L700.546 228.089H702.495L701.356 227.52L678.007 215.831L675.958 214.806L654.885 204.266L653.046 203.345L633.922 193.772L632.255 192.937L614.825 184.218L613.304 183.459L597.377 175.48L595.965 174.778L581.34 167.463L580.056 166.818L566.56 160.062L565.376 159.474L552.909 153.231L551.807 152.681L540.25 146.903L539.221 146.381L528.476 141.011L527.528 140.537L517.511 135.518L516.619 135.072L507.257 130.385L506.428 129.977L497.659 125.584L496.875 125.195L488.652 121.078L487.924 120.717L480.183 116.846L479.5 116.495L472.205 112.852L471.559 112.529L464.683 109.085L464.073 108.781L457.571 105.527L456.997 105.243L450.841 102.159L450.295 101.884L444.457 98.9617L443.938 98.7056L438.401 95.9351L437.901 95.6885L432.637 93.0509L432.173 92.8137L427.155 90.3089L426.709 90.0812L421.937 87.6998L421.509 87.4816L416.955 85.2046L416.545 84.9958L412.192 82.8232L411.81 82.6239L407.648 80.5461L407.275 80.3564L403.295 78.3639L402.94 78.1932L399.124 76.2766L398.778 76.1059L395.127 74.2843L394.799 74.1135L391.293 72.3582L390.974 72.2064L387.604 70.5176L387.304 70.3658L384.071 68.7434L383.78 68.6011L380.665 67.0451L380.383 66.9028L377.387 65.4038L377.114 65.2709L374.227 63.8193L373.972 63.696L371.185 62.3013L370.93 62.178L368.253 60.8307L368.007 60.7073L365.421 59.417L365.184 59.2937L362.68 58.0413L362.452 57.9275L360.039 56.7225L359.82 56.6087L357.48 55.4417L357.37 55.3848Z'
                      fill='white'
                    />
                    <path
                      d='M380.693 55.3848H380.092L380.22 55.4417L382.906 56.6087L383.161 56.7225L385.939 57.9275L386.194 58.0413L389.071 59.2937L389.345 59.417L392.323 60.7073L392.605 60.8307L395.683 62.178L395.974 62.3013L399.171 63.696L399.471 63.8193L402.795 65.2709L403.105 65.4038L406.547 66.9028L406.875 67.0451L410.454 68.6011L410.782 68.7434L414.506 70.3658L414.852 70.5176L418.732 72.2064L419.087 72.3582L423.121 74.1135L423.504 74.2843L427.702 76.1059L428.093 76.2766L432.474 78.1932L432.884 78.3639L437.464 80.3564L437.892 80.5461L442.673 82.6239L443.119 82.8232L448.119 84.9958L448.593 85.2046L453.829 87.4816L454.321 87.6998L459.812 90.0812L460.322 90.3089L466.087 92.8137L466.624 93.0509L472.671 95.6885L473.244 95.9351L479.61 98.7056L480.211 98.9617L486.914 101.884L487.551 102.159L494.627 105.243L495.292 105.527L502.759 108.781L503.46 109.085L511.365 112.529L512.112 112.852L520.49 116.495L521.282 116.846L530.179 120.717L531.017 121.078L540.47 125.195L541.371 125.584L551.452 129.977L552.399 130.385L563.173 135.072L564.193 135.518L575.713 140.537L576.805 141.011L589.154 146.381L590.338 146.903L603.615 152.681L604.881 153.231L619.215 159.474L620.581 160.062L636.09 166.818L637.574 167.463L654.385 174.778L656.006 175.48L674.319 183.459L676.068 184.218L696.103 192.937L698.024 193.772L720.008 203.345L722.12 204.266L746.344 214.806L748.703 215.831L775.549 227.52L776.851 228.089H778.791L777.489 227.52L750.551 215.831L748.184 214.806L723.878 204.266L721.756 203.345L699.7 193.772L697.769 192.937L677.671 184.218L675.913 183.459L657.536 175.48L655.915 174.778L639.04 167.463L637.556 166.818L621.993 160.062L620.627 159.474L606.238 153.231L604.972 152.681L591.649 146.903L590.456 146.381L578.062 141.011L576.969 140.537L565.413 135.518L564.384 135.072L553.583 130.385L552.627 129.977L542.51 125.584L541.617 125.195L532.128 121.078L531.281 120.717L522.357 116.846L521.564 116.495L513.159 112.852L512.412 112.529L504.471 109.085L503.77 108.781L496.275 105.527L495.61 105.243L488.507 102.159L487.879 101.884L481.14 98.9617L480.548 98.7056L474.155 95.9351L473.581 95.6885L467.516 93.0509L466.97 92.8137L461.187 90.3089L460.677 90.0812L455.168 87.6998L454.676 87.4816L449.412 85.2046L448.948 84.9958L443.93 82.8232L443.484 82.6239L438.685 80.5461L438.257 80.3564L433.658 78.3639L433.248 78.1932L428.849 76.2766L428.458 76.1059L424.241 74.2843L423.868 74.1135L419.816 72.3582L419.451 72.2064L415.572 70.5176L415.217 70.3658L411.483 68.7434L411.146 68.6011L407.558 67.0451L407.239 66.9028L403.779 65.4038L403.469 65.2709L400.136 63.8193L399.836 63.696L396.621 62.3013L396.33 62.178L393.242 60.8307L392.96 60.7073L389.973 59.417L389.7 59.2937L386.813 58.0413L386.549 57.9275L383.762 56.7225L383.507 56.6087L380.812 55.4417L380.693 55.3848Z'
                      fill='white'
                    />
                  </g>
                  <g
                    style={{
                      mixBlendMode: "overlay",
                    }}
                  >
                    <path
                      d='M7.58395 55.3838H6.992L6.84625 55.4407L3.79553 56.6077L3.51318 56.7216L0.344086 57.9265L0.0527344 58.0403L-3.21664 59.2927L-3.52625 59.4161L-6.91391 60.7064L-7.2326 60.8297L-10.7386 62.177L-11.0666 62.3003L-14.7001 63.695L-15.0462 63.8183L-18.8164 65.27L-19.1714 65.4028L-23.0873 66.9018L-23.4516 67.0442L-27.5223 68.6001L-27.9048 68.7424L-32.1393 70.3649L-32.531 70.5167L-36.9386 72.2055L-37.3484 72.3572L-41.929 74.1125L-42.3571 74.2833L-47.1381 76.1049L-47.5843 76.2757L-52.5656 78.1922L-53.0301 78.363L-58.2391 80.3554L-58.7217 80.5451L-64.1584 82.6229L-64.6684 82.8222L-70.351 84.9949L-70.8882 85.2036L-76.844 87.4806L-77.3995 87.6988L-83.6376 90.0803L-84.2295 90.308L-90.7772 92.8127L-91.3965 93.0499L-98.2721 95.6875L-98.9186 95.9342L-106.158 98.7046L-106.832 98.9607L-114.464 101.883L-115.183 102.158L-123.224 105.242L-123.98 105.526L-132.477 108.78L-133.269 109.084L-142.266 112.528L-143.113 112.851L-152.639 116.494L-153.54 116.845L-163.649 120.716L-164.605 121.077L-175.36 125.194L-176.371 125.583L-187.836 129.976L-188.92 130.384L-201.159 135.071L-202.316 135.517L-215.42 140.536L-216.659 141.01L-230.701 146.38L-232.049 146.902L-247.148 152.68L-248.587 153.23L-264.888 159.473L-266.436 160.061L-284.075 166.817L-285.751 167.462L-304.875 174.777L-306.715 175.479L-327.532 183.458L-329.527 184.217L-352.302 192.936L-354.488 193.771L-379.486 203.344L-381.881 204.265L-409.429 214.805L-412.106 215.83L-442.632 227.519L-444.116 228.088H-442.167L-440.692 227.519L-410.257 215.83L-407.589 214.805L-380.132 204.265L-377.737 203.344L-352.812 193.771L-350.636 192.936L-327.924 184.217L-325.939 183.458L-305.185 175.479L-303.345 174.777L-284.285 167.462L-282.609 166.817L-265.024 160.061L-263.485 159.473L-247.23 153.23L-245.8 152.68L-230.738 146.902L-229.399 146.38L-215.402 141.01L-214.163 140.536L-201.095 135.517L-199.948 135.071L-187.736 130.384L-186.661 129.976L-175.232 125.583L-174.212 125.194L-163.503 121.077L-162.547 120.716L-152.466 116.845L-151.564 116.494L-142.066 112.851L-141.228 112.528L-132.258 109.084L-131.466 108.78L-122.997 105.526L-122.241 105.242L-114.218 102.158L-113.507 101.883L-105.903 98.9607L-105.22 98.7046L-98.0079 95.9342L-97.3614 95.6875L-90.504 93.0499L-89.8939 92.8127L-83.3643 90.308L-82.7725 90.0803L-76.5526 87.6988L-75.9971 87.4806L-70.0595 85.2036L-69.5313 84.9949L-63.8579 82.8222L-63.357 82.6229L-57.9295 80.5451L-57.4468 80.3554L-52.256 78.363L-51.7916 78.1922L-46.8284 76.2757L-46.3822 76.1049L-41.6194 74.2833L-41.1914 74.1125L-36.6198 72.3572L-36.2101 72.2055L-31.8206 70.5167L-31.4291 70.3649L-27.2036 68.7424L-26.8211 68.6001L-22.7686 67.0442L-22.4044 66.9018L-18.4976 65.4028L-18.1424 65.27L-14.3813 63.8183L-14.0444 63.695L-10.4108 62.3003L-10.0921 62.177L-6.59518 60.8297L-6.27649 60.7064L-2.89783 59.4161L-2.59735 59.2927L0.671906 58.0403L0.963379 57.9265L4.11426 56.7216L4.39661 56.6077L7.44733 55.4407L7.58395 55.3838Z'
                      fill='white'
                    />
                    <path
                      d='M30.8971 55.3838H30.3051L30.1867 55.4407L27.4912 56.6077L27.2362 56.7216L24.4404 57.9265L24.1855 58.0403L21.2986 59.2927L21.0254 59.4161L18.0385 60.7064L17.7561 60.8297L14.6598 62.177L14.3776 62.3003L11.1629 63.695L10.8624 63.8183L7.52936 65.27L7.21976 65.4028L3.75919 66.9018L3.44046 67.0442L-0.156616 68.6001L-0.484558 68.7424L-4.22739 70.3649L-4.57346 70.5167L-8.46188 72.2055L-8.82617 72.3572L-12.8696 74.1125L-13.252 74.2833L-17.4593 76.1049L-17.86 76.2757L-22.2585 78.1922L-22.6684 78.363L-27.2581 80.3554L-27.6862 80.5451L-32.4853 82.6229L-32.9406 82.8222L-37.9493 84.9949L-38.4229 85.2036L-43.6774 87.4806L-44.1692 87.6988L-49.6787 90.0803L-50.1978 90.308L-55.9805 92.8127L-56.5178 93.0499L-62.592 95.6875L-63.1566 95.9342L-69.5495 98.7046L-70.1506 98.9607L-76.8803 101.883L-77.5178 102.158L-84.612 105.242L-85.2858 105.526L-92.7715 108.78L-93.4818 109.084L-101.414 112.528L-102.16 112.851L-110.575 116.494L-111.367 116.845L-120.292 120.716L-121.139 121.077L-130.619 125.194L-131.52 125.583L-141.638 129.976L-142.594 130.384L-153.395 135.071L-154.414 135.517L-165.98 140.536L-167.073 141.01L-179.467 146.38L-180.66 146.902L-193.983 152.68L-195.249 153.23L-209.637 159.473L-211.003 160.061L-226.567 166.817L-228.051 167.462L-244.926 174.777L-246.547 175.479L-264.924 183.458L-266.682 184.217L-286.78 192.936L-288.711 193.771L-310.776 203.344L-312.889 204.265L-337.204 214.805L-339.562 215.83L-366.5 227.519L-367.811 228.088H-365.871L-364.56 227.519L-337.714 215.83L-335.364 214.805L-311.131 204.265L-309.028 203.344L-287.035 193.771L-285.113 192.936L-265.079 184.217L-263.33 183.458L-245.017 175.479L-243.396 174.777L-226.585 167.462L-225.1 166.817L-209.592 160.061L-208.226 159.473L-193.892 153.23L-192.626 152.68L-179.349 146.902L-178.165 146.38L-165.816 141.01L-164.723 140.536L-153.194 135.517L-152.174 135.071L-141.41 130.384L-140.454 129.976L-130.373 125.583L-129.48 125.194L-120.028 121.077L-119.19 120.716L-110.293 116.845L-109.5 116.494L-101.122 112.851L-100.376 112.528L-92.4709 109.084L-91.7607 108.78L-84.2931 105.526L-83.6284 105.242L-76.5525 102.158L-75.9242 101.883L-69.2126 98.9607L-68.6206 98.7046L-62.2459 95.9342L-61.6813 95.6875L-55.6345 93.0499L-55.0881 92.8127L-49.3326 90.308L-48.8136 90.0803L-43.3222 87.6988L-42.8306 87.4806L-37.5942 85.2036L-37.1298 84.9949L-32.1302 82.8222L-31.6839 82.6229L-26.8939 80.5451L-26.4658 80.3554L-21.8942 78.363L-21.4845 78.1922L-17.0951 76.2757L-16.7035 76.1049L-12.5053 74.2833L-12.1319 74.1125L-8.09772 72.3572L-7.73343 72.2055L-3.8631 70.5167L-3.51703 70.3649L0.20755 68.7424L0.544495 68.6001L4.12347 67.0442L4.44217 66.9018L7.89365 65.4028L8.20325 65.27L11.5181 63.8183L11.8186 63.695L15.0241 62.3003L15.3065 62.177L18.3936 60.8297L18.6759 60.7064L21.6538 59.4161L21.9179 59.2927L24.7956 58.0403L25.0597 57.9265L27.8373 56.7216L28.0922 56.6077L30.7787 55.4407L30.8971 55.3838Z'
                      fill='white'
                    />
                    <path
                      d='M54.2189 55.3838H53.627L53.5177 55.4407L51.1864 56.6077L50.9678 56.7216L48.5455 57.9265L48.3178 58.0403L45.8135 59.2927L45.5858 59.4161L42.9904 60.7064L42.7537 60.8297L40.0671 62.177L39.8121 62.3003L37.0346 63.695L36.7705 63.8183L33.8838 65.27L33.6105 65.4028L30.6144 66.9018L30.3322 67.0442L27.2267 68.6001L26.9354 68.7424L23.6934 70.3649L23.3929 70.5167L20.0233 72.2055L19.7047 72.3572L16.1986 74.1125L15.8708 74.2833L12.219 76.1049L11.8729 76.2757L8.06628 78.1922L7.71112 78.363L3.72238 80.3554L3.34909 80.5451L-0.803589 82.6229L-1.19513 82.8222L-5.54813 84.9949L-5.94888 85.2036L-10.5112 87.4806L-10.9302 87.6988L-15.7112 90.0803L-16.1574 90.308L-21.1661 92.8127L-21.6396 93.0499L-26.9032 95.6875L-27.395 95.9342L-32.9319 98.7046L-33.4601 98.9607L-39.2884 101.883L-39.8439 102.158L-45.9909 105.242L-46.5737 105.526L-53.0668 108.78L-53.686 109.084L-60.5615 112.528L-61.2081 112.851L-68.5025 116.494L-69.1855 116.845L-76.9262 120.716L-77.6548 121.077L-85.878 125.194L-86.6522 125.583L-95.4219 129.976L-96.2505 130.384L-105.621 135.071L-106.505 135.517L-116.531 140.536L-117.478 141.01L-128.224 146.38L-129.253 146.902L-140.8 152.68L-141.902 153.23L-154.378 159.473L-155.562 160.061L-169.049 166.817L-170.333 167.462L-184.968 174.777L-186.37 175.479L-202.298 183.458L-203.828 184.217L-221.249 192.936L-222.924 193.771L-242.048 203.344L-243.888 204.265L-264.952 214.805L-267.001 215.83L-290.359 227.519L-291.488 228.088H-289.549L-288.419 227.519L-265.161 215.83L-263.112 214.805L-242.13 204.265L-240.3 203.344L-221.249 193.771L-219.582 192.936L-202.225 184.217L-200.704 183.458L-184.84 175.479L-183.438 174.777L-168.867 167.462L-167.583 166.817L-154.151 160.061L-152.967 159.473L-140.545 153.23L-139.453 152.68L-127.942 146.902L-126.913 146.38L-116.212 141.01L-115.265 140.536L-105.284 135.517L-104.401 135.071L-95.0758 130.384L-94.2471 129.976L-85.5138 125.583L-84.7397 125.194L-76.5437 121.077L-75.8152 120.716L-68.1109 116.845L-67.4279 116.494L-60.1699 112.851L-59.5234 112.528L-52.666 109.084L-52.0559 108.78L-45.5901 105.526L-45.0073 105.242L-38.8785 102.158L-38.3321 101.883L-32.5221 98.9607L-32.0031 98.7046L-26.4843 95.9342L-25.9926 95.6875L-20.7562 93.0499L-20.2828 92.8127L-15.2922 90.308L-14.846 90.0803L-10.0923 87.6988L-9.66437 87.4806L-5.12015 85.2036L-4.71939 84.9949L-0.384613 82.8222L-0.00219727 82.6229L4.14139 80.5451L4.51477 80.3554L8.47617 78.363L8.83133 78.1922L12.6378 76.2757L12.9748 76.1049L16.6175 74.2833L16.9362 74.1125L20.4332 72.3572L20.7519 72.2055L24.1031 70.5167L24.4037 70.3649L27.6274 68.7424L27.9189 68.6001L31.0243 67.0442L31.2974 66.9018L34.2844 65.4028L34.5577 65.27L37.4353 63.8183L37.6903 63.695L40.4679 62.3003L40.7138 62.177L43.3911 60.8297L43.6279 60.7064L46.205 59.4161L46.4418 59.2927L48.937 58.0403L49.1647 57.9265L51.5688 56.7216L51.7874 56.6077L54.1188 55.4407L54.2189 55.3838Z'
                      fill='#1C1C1C'
                      fill-opacity='0.6'
                    />
                    <path
                      d='M77.5412 55.3838H76.9401L76.8582 55.4407L74.8729 56.6077L74.6908 56.7216L72.6418 57.9265L72.4506 58.0403L70.3286 59.2927L70.1375 59.4161L67.9427 60.7064L67.7333 60.8297L65.4657 62.177L65.2563 62.3003L62.8977 63.695L62.6791 63.8183L60.2294 65.27L60.0017 65.4028L57.4701 66.9018L57.2242 67.0442L54.5924 68.6001L54.3465 68.7424L51.6054 70.3649L51.3504 70.5167L48.5 72.2055L48.2359 72.3572L45.2581 74.1125L44.9848 74.2833L41.8885 76.1049L41.6063 76.2757L38.3734 78.1922L38.0729 78.363L34.7034 80.3554L34.3847 80.5451L30.8695 82.6229L30.5417 82.8222L26.8534 84.9949L26.5165 85.2036L22.6553 87.4806L22.291 87.6988L18.2477 90.0803L17.8743 90.308L13.6305 92.8127L13.2299 93.0499L8.77673 95.6875L8.35786 95.9342L3.66791 98.7046L3.2308 98.9607L-1.70505 101.883L-2.16949 102.158L-7.37849 105.242L-7.87029 105.526L-13.3706 108.78L-13.8898 109.084L-19.709 112.528L-20.2645 112.851L-26.4297 116.494L-27.0125 116.845L-33.5602 120.716L-34.1795 121.077L-41.146 125.194L-41.8017 125.583L-49.2236 129.976L-49.9248 130.384L-57.8568 135.071L-58.6035 135.517L-67.0909 140.536L-67.8922 141.01L-76.9898 146.38L-77.855 146.902L-87.6355 152.68L-88.5644 153.23L-99.1282 159.473L-100.13 160.061L-111.55 166.817L-112.633 167.462L-125.018 174.777L-126.211 175.479L-139.689 183.458L-140.982 184.217L-155.735 192.936L-157.147 193.771L-173.338 203.344L-174.896 204.265L-192.726 214.805L-194.466 215.83L-214.227 227.519L-215.193 228.088H-213.244L-212.288 227.519L-192.617 215.83L-190.887 214.805L-173.138 204.265L-171.59 203.344L-155.471 193.771L-154.069 192.936L-139.38 184.217L-138.096 183.458L-124.682 175.479L-123.488 174.777L-111.167 167.462L-110.083 166.817L-98.7184 160.061L-97.7166 159.473L-87.2076 153.23L-86.2878 152.68L-76.5527 146.902L-75.6785 146.38L-66.6265 141.01L-65.8251 140.536L-57.3832 135.517L-56.6364 135.071L-48.7501 130.384L-48.0489 129.976L-40.6634 125.583L-40.0076 125.194L-33.0775 121.077L-32.4583 120.716L-25.9379 116.845L-25.3642 116.494L-19.2171 112.851L-18.6708 112.528L-12.879 109.084L-12.3598 108.78L-6.88669 105.526L-6.395 105.242L-1.21326 102.158L-0.74881 101.883L4.16881 98.9607L4.60591 98.7046L9.26852 95.9342L9.68739 95.6875L14.1223 93.0499L14.514 92.8127L18.7395 90.308L19.1128 90.0803L23.138 87.6988L23.5022 87.4806L27.3361 85.2036L27.6822 84.9949L31.3431 82.8222L31.6709 82.6229L35.1769 80.5451L35.4957 80.3554L38.847 78.363L39.1474 78.1922L42.3621 76.2757L42.6445 76.1049L45.7225 74.2833L46.0048 74.1125L48.9554 72.3572L49.2195 72.2055L52.0607 70.5167L52.3158 70.3649L55.0478 68.7424L55.2935 68.6001L57.9163 67.0442L58.153 66.9018L60.6756 65.4028L60.9033 65.27L63.3348 63.8183L63.5533 63.695L65.9028 62.3003L66.1123 62.177L68.3708 60.8297L68.5803 60.7064L70.7567 59.4161L70.9571 59.2927L73.0698 58.0403L73.2611 57.9265L75.2919 56.7216L75.4831 56.6077L77.4501 55.4407L77.5412 55.3838Z'
                      fill='#1C1C1C'
                      fill-opacity='0.6'
                    />
                    <path
                      d='M100.864 55.3838H100.263L100.19 55.4407L98.569 56.6077L98.4233 56.7216L96.7476 57.9265L96.5929 58.0403L94.8535 59.2927L94.6895 59.4161L92.8955 60.7064L92.7317 60.8297L90.8739 62.177L90.7008 62.3003L88.7702 63.695L88.5881 63.8183L86.5847 65.27L86.4025 65.4028L84.3261 66.9018L84.1258 67.0442L81.9675 68.6001L81.7672 68.7424L79.527 70.3649L79.3175 70.5167L76.9771 72.2055L76.7677 72.3572L74.3362 74.1125L74.1085 74.2833L71.5768 76.1049L71.34 76.2757L68.6992 78.1922L68.4442 78.363L65.6848 80.3554L65.4298 80.5451L62.5522 82.6229L62.2789 82.8222L59.2647 84.9949L58.9823 85.2036L55.8223 87.4806L55.5309 87.6988L52.2251 90.0803L51.9155 90.308L48.4368 92.8127L48.109 93.0499L44.4663 95.6875L44.1203 95.9342L40.2863 98.7046L39.922 98.9607L35.8787 101.883L35.5053 102.158L31.2343 105.242L30.8336 105.526L26.3349 108.78L25.907 109.084L21.1441 112.528L20.6978 112.851L15.6437 116.494L15.1702 116.845L9.80632 120.716L9.2964 121.077L3.60474 125.194L3.06735 125.583L-3.01584 129.976L-3.58955 130.384L-10.0735 135.071L-10.6928 135.517L-17.6321 140.536L-18.2968 141.01L-25.737 146.38L-26.4564 146.902L-34.4612 152.68L-35.217 153.23L-43.8593 159.473L-44.6788 160.061L-54.0314 166.817L-54.9238 167.462L-65.0596 174.777L-66.034 175.479L-77.0713 183.458L-78.1276 184.217L-90.2031 192.936L-91.3596 193.771L-104.61 203.344L-105.885 204.265L-120.483 214.805L-121.903 215.83L-138.086 227.519L-138.869 228.088H-136.929L-136.146 227.519L-120.055 215.83L-118.643 214.805L-104.127 204.265L-102.861 203.344L-89.684 193.771L-88.5275 192.936L-76.5249 184.217L-75.4776 183.458L-64.5041 175.479L-63.5297 174.777L-53.4486 167.462L-52.5652 166.817L-43.2674 160.061L-42.4569 159.473L-33.8601 153.23L-33.1043 152.68L-25.1451 146.902L-24.4347 146.38L-17.031 141.01L-16.3754 140.536L-9.47253 135.517L-8.86235 135.071L-2.40576 130.384L-1.84114 129.976L4.20569 125.583L4.74307 125.194L10.4074 121.077L10.9082 120.716L16.2447 116.845L16.7182 116.494L21.736 112.851L22.1823 112.528L26.9269 109.084L27.3458 108.78L31.8263 105.526L32.2178 105.242L36.4615 102.158L36.8441 101.883L40.86 98.9607L41.2152 98.7046L45.0309 95.9342L45.377 95.6875L49.0014 93.0499L49.3293 92.8127L52.7807 90.308L53.0903 90.0803L56.3778 87.6988L56.6692 87.4806L59.8111 85.2036L60.0933 84.9949L63.0894 82.8222L63.3536 82.6229L66.2221 80.5451L66.4771 80.3554L69.2182 78.363L69.4641 78.1922L72.0959 76.2757L72.3327 76.1049L74.8462 74.2833L75.0738 74.1125L77.487 72.3572L77.7057 72.2055L80.0278 70.5167L80.2372 70.3649L82.4684 68.7424L82.6688 68.6001L84.8088 67.0442L85.0091 66.9018L87.0672 65.4028L87.2586 65.27L89.2438 63.8183L89.4259 63.695L91.3474 62.3003L91.5204 62.177L93.3691 60.8297L93.5331 60.7064L95.3179 59.4161L95.4818 59.2927L97.203 58.0403L97.3578 57.9265L99.0243 56.7216L99.1792 56.6077L100.791 55.4407L100.864 55.3838Z'
                      fill='#1C1C1C'
                      fill-opacity='0.6'
                    />
                    <path
                      d='M124.177 55.3838H123.585L123.521 55.4407L122.264 56.6077L122.146 56.7216L120.844 57.9265L120.716 58.0403L119.368 59.2927L119.241 59.4161L117.847 60.7064L117.72 60.8297L116.272 62.177L116.135 62.3003L114.633 63.695L114.487 63.8183L112.93 65.27L112.784 65.4028L111.172 66.9018L111.017 67.0442L109.342 68.6001L109.187 68.7424L107.438 70.3649L107.275 70.5167L105.453 72.2055L105.289 72.3572L103.395 74.1125L103.222 74.2833L101.246 76.1049L101.064 76.2757L99.0057 78.1922L98.8145 78.363L96.6653 80.3554L96.465 80.5451L94.2247 82.6229L94.0152 82.8222L91.6658 84.9949L91.4472 85.2036L88.9883 87.4806L88.7607 87.6988L86.1835 90.0803L85.9376 90.308L83.2421 92.8127L82.9871 93.0499L80.1458 95.6875L79.8817 95.9342L76.8948 98.7046L76.6124 98.9607L73.4615 101.883L73.1701 102.158L69.8462 105.242L69.5365 105.526L66.0305 108.78L65.7027 109.084L61.9872 112.528L61.6411 112.851L57.707 116.494L57.3427 116.845L53.1628 120.716L52.7712 121.077L48.3363 125.194L47.9173 125.583L43.1819 129.976L42.7357 130.384L37.6905 135.071L37.2078 135.517L31.8077 140.536L31.2885 141.01L25.4967 146.38L24.9412 146.902L18.7123 152.68L18.1203 153.23L11.3905 159.473L10.7531 160.061L3.47683 166.817L2.7756 167.462L-5.11081 174.777L-5.86662 175.479L-14.4634 183.458L-15.283 184.217L-24.681 192.936L-25.5826 193.771L-35.9004 203.344L-36.8931 204.265L-48.2582 214.805L-49.3601 215.83L-61.9547 227.519L-62.5739 228.088H-60.625L-60.0149 227.519L-47.5114 215.83L-46.4186 214.805L-35.1355 204.265L-34.152 203.344L-23.907 193.771L-23.0145 192.936L-13.6802 184.217L-12.8697 183.458L-4.33676 175.479L-3.58084 174.777L4.25088 167.462L4.93388 166.817L12.1645 160.061L12.7929 159.473L19.4772 153.23L20.06 152.68L26.2526 146.902L26.799 146.38L32.5544 141.01L33.0644 140.536L38.4282 135.517L38.9017 135.071L43.9195 130.384L44.3657 129.976L49.0556 125.583L49.4746 125.194L53.8822 121.077L54.2737 120.716L58.4173 116.845L58.7816 116.494L62.6883 112.851L63.0343 112.528L66.7135 109.084L67.0413 108.78L70.5201 105.526L70.8297 105.242L74.1263 102.158L74.4177 101.883L77.5413 98.9607L77.8237 98.7046L80.7923 95.9342L81.0565 95.6875L83.8704 93.0499L84.1254 92.8127L86.812 90.308L87.0486 90.0803L89.6077 87.6988L89.8353 87.4806L92.276 85.2036L92.4945 84.9949L94.8166 82.8222L95.0261 82.6229L97.2573 80.5451L97.4576 80.3554L99.5885 78.363L99.7798 78.1922L101.82 76.2757L102.002 76.1049L103.96 74.2833L104.133 74.1125L106.018 72.3572L106.182 72.2055L107.985 70.5167L108.149 70.3649L109.879 68.7424L110.034 68.6001L111.7 67.0442L111.855 66.9018L113.458 65.4028L113.604 65.27L115.152 63.8183L115.288 63.695L116.782 62.3003L116.919 62.177L118.348 60.8297L118.485 60.7064L119.869 59.4161L119.997 59.2927L121.335 58.0403L121.454 57.9265L122.747 56.7216L122.865 56.6077L124.122 55.4407L124.177 55.3838Z'
                      fill='#1C1C1C'
                      fill-opacity='0.6'
                    />
                    <path
                      d='M147.5 55.3838H146.908L146.863 55.4407L145.961 56.6077L145.879 56.7216L144.941 57.9265L144.859 58.0403L143.894 59.2927L143.803 59.4161L142.801 60.7064L142.71 60.8297L141.672 62.177L141.581 62.3003L140.506 63.695L140.406 63.8183L139.286 65.27L139.186 65.4028L138.029 66.9018L137.92 67.0442L136.718 68.6001L136.609 68.7424L135.361 70.3649L135.243 70.5167L133.94 72.2055L133.822 72.3572L132.465 74.1125L132.338 74.2833L130.926 76.1049L130.799 76.2757L129.323 78.1922L129.187 78.363L127.657 80.3554L127.511 80.5451L125.908 82.6229L125.753 82.8222L124.078 84.9949L123.923 85.2036L122.165 87.4806L121.992 87.6988L120.153 90.0803L119.98 90.308L118.049 92.8127L117.867 93.0499L115.836 95.6875L115.645 95.9342L113.505 98.7046L113.305 98.9607L111.055 101.883L110.846 102.158L108.469 105.242L108.25 105.526L105.737 108.78L105.5 109.084L102.85 112.528L102.595 112.851L99.7904 116.494L99.5262 116.845L96.5392 120.716L96.257 121.077L93.0788 125.194L92.7782 125.583L89.3996 129.976L89.0809 130.384L85.4655 135.071L85.1194 135.517L81.2582 140.536L80.8849 141.01L76.7413 146.38L76.3497 146.902L71.8875 152.68L71.4685 153.23L66.6512 159.473L66.1959 160.061L60.9868 166.817L60.4951 167.462L54.8489 174.777L54.3116 175.479L48.1646 183.458L47.5727 184.217L40.8519 192.936L40.2054 193.771L32.829 203.344L32.1187 204.265L23.9864 214.805L23.1941 215.83L14.1877 227.519L13.7505 228.088H15.6902L16.1274 227.519L25.0428 215.83L25.8259 214.805L33.8763 204.265L34.5774 203.344L41.881 193.771L42.5185 192.936L49.1754 184.217L49.7583 183.458L55.8416 175.479L56.3788 174.777L61.9612 167.462L62.453 166.817L67.6073 160.061L68.0627 159.473L72.8254 153.23L73.2444 152.68L77.652 146.902L78.0528 146.38L82.1508 141.01L82.5149 140.536L86.3398 135.517L86.6859 135.071L90.2556 130.384L90.5744 129.976L93.9256 125.583L94.2171 125.194L97.3588 121.077L97.6411 120.716L100.592 116.845L100.856 116.494L103.642 112.851L103.888 112.528L106.52 109.084L106.748 108.78L109.234 105.526L109.453 105.242L111.802 102.158L112.011 101.883L114.243 98.9607L114.443 98.7046L116.556 95.9342L116.747 95.6875L118.75 93.0499L118.932 92.8127L120.845 90.308L121.018 90.0803L122.839 87.6988L123.003 87.4806L124.743 85.2036L124.897 84.9949L126.564 82.8222L126.71 82.6229L128.303 80.5451L128.44 80.3554L129.961 78.363L130.097 78.1922L131.554 76.2757L131.682 76.1049L133.084 74.2833L133.203 74.1125L134.541 72.3572L134.669 72.2055L135.953 70.5167L136.071 70.3649L137.301 68.7424L137.419 68.6001L138.603 67.0442L138.712 66.9018L139.86 65.4028L139.96 65.27L141.062 63.8183L141.162 63.695L142.227 62.3003L142.318 62.177L143.348 60.8297L143.439 60.7064L144.431 59.4161L144.513 59.2927L145.469 58.0403L145.56 57.9265L146.48 56.7216L146.562 56.6077L147.464 55.4407L147.5 55.3838Z'
                      fill='#1C1C1C'
                      fill-opacity='0.6'
                    />
                    <path
                      d='M170.822 55.3838H170.221L170.193 55.4407L169.656 56.6077L169.601 56.7216L169.046 57.9265L168.991 58.0403L168.408 59.2927L168.354 59.4161L167.753 60.7064L167.698 60.8297L167.07 62.177L167.015 62.3003L166.368 63.695L166.305 63.8183L165.64 65.27L165.576 65.4028L164.875 66.9018L164.811 67.0442L164.092 68.6001L164.019 68.7424L163.272 70.3649L163.199 70.5167L162.416 72.2055L162.343 72.3572L161.524 74.1125L161.451 74.2833L160.604 76.1049L160.522 76.2757L159.639 78.1922L159.557 78.363L158.628 80.3554L158.546 80.5451L157.581 82.6229L157.489 82.8222L156.479 84.9949L156.378 85.2036L155.322 87.4806L155.222 87.6988L154.111 90.0803L154.011 90.308L152.845 92.8127L152.736 93.0499L151.515 95.6875L151.397 95.9342L150.113 98.7046L149.995 98.9607L148.638 101.883L148.51 102.158L147.081 105.242L146.944 105.526L145.432 108.78L145.296 109.084L143.693 112.528L143.547 112.851L141.853 116.494L141.689 116.845L139.895 120.716L139.722 121.077L137.819 125.194L137.637 125.583L135.597 129.976L135.406 130.384L133.229 135.071L133.02 135.517L130.698 140.536L130.47 141.01L127.975 146.38L127.738 146.902L125.052 152.68L124.797 153.23L121.901 159.473L121.627 160.061L118.495 166.817L118.194 167.462L114.797 174.777L114.47 175.479L110.772 183.458L110.417 184.217L106.365 192.936L105.982 193.771L101.538 203.344L101.11 204.265L96.2198 214.805L95.7371 215.83L90.3187 227.519L90.0546 228.088H92.0125L92.2675 227.519L97.604 215.83L98.0685 214.805L102.886 204.265L103.305 203.344L107.667 193.771L108.049 192.936L112.029 184.217L112.375 183.458L116.018 175.479L116.336 174.777L119.679 167.462L119.97 166.817L123.048 160.061L123.321 159.473L126.172 153.23L126.427 152.68L129.058 146.902L129.295 146.38L131.745 141.01L131.963 140.536L134.258 135.517L134.459 135.071L136.599 130.384L136.781 129.976L138.784 125.583L138.966 125.194L140.842 121.077L141.006 120.716L142.773 116.845L142.937 116.494L144.594 112.851L144.749 112.528L146.316 109.084L146.452 108.78L147.937 105.526L148.073 105.242L149.476 102.158L149.603 101.883L150.933 98.9607L151.051 98.7046L152.317 95.9342L152.435 95.6875L153.637 93.0499L153.738 92.8127L154.885 90.308L154.985 90.0803L156.078 87.6988L156.178 87.4806L157.216 85.2036L157.307 84.9949L158.3 82.8222L158.391 82.6229L159.338 80.5451L159.429 80.3554L160.331 78.363L160.413 78.1922L161.287 76.2757L161.369 76.1049L162.198 74.2833L162.27 74.1125L163.072 72.3572L163.145 72.2055L163.919 70.5167L163.983 70.3649L164.729 68.7424L164.793 68.6001L165.503 67.0442L165.567 66.9018L166.25 65.4028L166.314 65.27L166.969 63.8183L167.033 63.695L167.671 62.3003L167.725 62.177L168.335 60.8297L168.39 60.7064L168.982 59.4161L169.037 59.2927L169.61 58.0403L169.665 57.9265L170.211 56.7216L170.266 56.6077L170.794 55.4407L170.822 55.3838Z'
                      fill='#1C1C1C'
                      fill-opacity='0.6'
                    />
                    <path
                      d='M217.458 55.3838H216.857L216.866 55.4407L217.048 56.6077L217.057 56.7216L217.239 57.9265L217.257 58.0403L217.449 59.2927L217.467 59.4161L217.658 60.7064L217.676 60.8297L217.877 62.177L217.895 62.3003L218.104 63.695L218.123 63.8183L218.341 65.27L218.359 65.4028L218.578 66.9018L218.605 67.0442L218.833 68.6001L218.86 68.7424L219.097 70.3649L219.124 70.5167L219.37 72.2055L219.397 72.3572L219.662 74.1125L219.689 74.2833L219.962 76.1049L219.98 76.2757L220.272 78.1922L220.299 78.363L220.59 80.3554L220.618 80.5451L220.936 82.6229L220.964 82.8222L221.283 84.9949L221.319 85.2036L221.656 87.4806L221.692 87.6988L222.048 90.0803L222.084 90.308L222.457 92.8127L222.494 93.0499L222.885 95.6875L222.922 95.9342L223.332 98.7046L223.377 98.9607L223.814 101.883L223.851 102.158L224.315 105.242L224.351 105.526L224.843 108.78L224.889 109.084L225.399 112.528L225.453 112.851L225.991 116.494L226.045 116.845L226.628 120.716L226.683 121.077L227.293 125.194L227.357 125.583L228.012 129.976L228.067 130.384L228.768 135.071L228.841 135.517L229.588 140.536L229.661 141.01L230.462 146.38L230.535 146.902L231.4 152.68L231.482 153.23L232.42 159.473L232.502 160.061L233.513 166.817L233.613 167.462L234.706 174.777L234.815 175.479L235.999 183.458L236.117 184.217L237.42 192.936L237.547 193.771L238.977 203.344L239.113 204.265L240.689 214.805L240.844 215.83L242.592 227.519L242.674 228.088H244.632L244.541 227.519L242.701 215.83L242.547 214.805L240.889 204.265L240.743 203.344L239.232 193.771L239.104 192.936L237.729 184.217L237.611 183.458L236.354 175.479L236.245 174.777L235.097 167.462L234.997 166.817L233.932 160.061L233.841 159.473L232.857 153.23L232.766 152.68L231.855 146.902L231.783 146.38L230.936 141.01L230.854 140.536L230.07 135.517L229.998 135.071L229.26 130.384L229.196 129.976L228.504 125.583L228.44 125.194L227.794 121.077L227.739 120.716L227.129 116.845L227.074 116.494L226.501 112.851L226.455 112.528L225.909 109.084L225.863 108.78L225.353 105.526L225.308 105.242L224.816 102.158L224.78 101.883L224.315 98.9607L224.279 98.7046L223.842 95.9342L223.805 95.6875L223.386 93.0499L223.35 92.8127L222.958 90.308L222.922 90.0803L222.539 87.6988L222.512 87.4806L222.148 85.2036L222.12 84.9949L221.774 82.8222L221.747 82.6229L221.419 80.5451L221.392 80.3554L221.073 78.363L221.046 78.1922L220.745 76.2757L220.718 76.1049L220.436 74.2833L220.408 74.1125L220.135 72.3572L220.108 72.2055L219.844 70.5167L219.816 70.3649L219.561 68.7424L219.543 68.6001L219.297 67.0442L219.27 66.9018L219.033 65.4028L219.015 65.27L218.787 63.8183L218.769 63.695L218.551 62.3003L218.532 62.177L218.314 60.8297L218.296 60.7064L218.095 59.4161L218.077 59.2927L217.877 58.0403L217.858 57.9265L217.667 56.7216L217.649 56.6077L217.467 55.4407L217.458 55.3838Z'
                      fill='#1C1C1C'
                      fill-opacity='0.6'
                    />
                    <path
                      d='M240.78 55.3838H240.178L240.206 55.4407L240.743 56.6077L240.789 56.7216L241.344 57.9265L241.399 58.0403L241.963 59.2927L242.018 59.4161L242.61 60.7064L242.665 60.8297L243.275 62.177L243.339 62.3003L243.976 63.695L244.031 63.8183L244.695 65.27L244.75 65.4028L245.433 66.9018L245.497 67.0442L246.216 68.6001L246.28 68.7424L247.018 70.3649L247.091 70.5167L247.855 72.2055L247.928 72.3572L248.73 74.1125L248.803 74.2833L249.64 76.1049L249.713 76.2757L250.587 78.1922L250.669 78.363L251.58 80.3554L251.662 80.5451L252.609 82.6229L252.7 82.8222L253.693 84.9949L253.784 85.2036L254.831 87.4806L254.922 87.6988L256.015 90.0803L256.115 90.308L257.263 92.8127L257.372 93.0499L258.574 95.6875L258.683 95.9342L259.949 98.7046L260.068 98.9607L261.397 101.883L261.525 102.158L262.927 105.242L263.064 105.526L264.548 108.78L264.685 109.084L266.26 112.528L266.406 112.851L268.072 116.494L268.227 116.845L269.994 120.716L270.158 121.077L272.043 125.194L272.216 125.583L274.219 129.976L274.411 130.384L276.551 135.071L276.751 135.517L279.037 140.536L279.255 141.01L281.705 146.38L281.942 146.902L284.583 152.68L284.828 153.23L287.679 159.473L287.952 160.061L291.03 166.817L291.322 167.462L294.664 174.777L294.992 175.479L298.625 183.458L298.971 184.217L302.951 192.936L303.333 193.771L307.704 203.344L308.123 204.265L312.932 214.805L313.396 215.83L318.733 227.519L318.988 228.088H320.936L320.672 227.519L315.245 215.83L314.771 214.805L309.881 204.265L309.453 203.344L305.009 193.771L304.617 192.936L300.574 184.217L300.219 183.458L296.521 175.479L296.194 174.777L292.797 167.462L292.496 166.817L289.364 160.061L289.09 159.473L286.194 153.23L285.939 152.68L283.253 146.902L283.016 146.38L280.521 141.01L280.293 140.536L277.971 135.517L277.762 135.071L275.585 130.384L275.394 129.976L273.363 125.583L273.181 125.194L271.269 121.077L271.096 120.716L269.302 116.845L269.138 116.494L267.453 112.851L267.298 112.528L265.704 109.084L265.559 108.78L264.047 105.526L263.91 105.242L262.49 102.158L262.362 101.883L261.005 98.9607L260.878 98.7046L259.594 95.9342L259.485 95.6875L258.255 93.0499L258.146 92.8127L256.989 90.308L256.88 90.0803L255.769 87.6988L255.669 87.4806L254.613 85.2036L254.521 84.9949L253.511 82.8222L253.42 82.6229L252.454 80.5451L252.363 80.3554L251.443 78.363L251.361 78.1922L250.469 76.2757L250.396 76.1049L249.549 74.2833L249.467 74.1125L248.657 72.3572L248.584 72.2055L247.801 70.5167L247.728 70.3649L246.972 68.7424L246.908 68.6001L246.189 67.0442L246.125 66.9018L245.424 65.4028L245.36 65.27L244.695 63.8183L244.632 63.695L243.985 62.3003L243.93 62.177L243.302 60.8297L243.247 60.7064L242.646 59.4161L242.592 59.2927L242.009 58.0403L241.954 57.9265L241.399 56.7216L241.344 56.6077L240.798 55.4407L240.78 55.3838Z'
                      fill='#1C1C1C'
                      fill-opacity='0.6'
                    />
                    <path
                      d='M264.102 55.3838H263.501L263.546 55.4407L264.439 56.6077L264.521 56.7216L265.449 57.9265L265.531 58.0403L266.488 59.2927L266.579 59.4161L267.562 60.7064L267.662 60.8297L268.682 62.177L268.783 62.3003L269.839 63.695L269.939 63.8183L271.041 65.27L271.15 65.4028L272.289 66.9018L272.398 67.0442L273.591 68.6001L273.7 68.7424L274.939 70.3649L275.048 70.5167L276.341 72.2055L276.459 72.3572L277.798 74.1125L277.926 74.2833L279.319 76.1049L279.446 76.2757L280.904 78.1922L281.04 78.363L282.561 80.3554L282.707 80.5451L284.291 82.6229L284.446 82.8222L286.103 84.9949L286.258 85.2036L287.998 87.4806L288.162 87.6988L289.983 90.0803L290.156 90.308L292.068 92.8127L292.25 93.0499L294.263 95.6875L294.445 95.9342L296.567 98.7046L296.767 98.9607L298.989 101.883L299.199 102.158L301.548 105.242L301.776 105.526L304.253 108.78L304.49 109.084L307.112 112.528L307.358 112.851L310.145 116.494L310.409 116.845L313.36 120.716L313.642 121.077L316.784 125.194L317.084 125.583L320.426 129.976L320.745 130.384L324.324 135.071L324.661 135.517L328.486 140.536L328.85 141.01L332.957 146.38L333.349 146.902L337.756 152.68L338.184 153.23L342.947 159.473L343.393 160.061L348.548 166.817L349.04 167.462L354.622 174.777L355.168 175.479L361.252 183.458L361.834 184.217L368.482 192.936L369.12 193.771L376.423 203.344L377.125 204.265L385.175 214.805L385.958 215.83L394.873 227.519L395.311 228.088H397.25L396.813 227.519L387.807 215.83L387.014 214.805L378.882 204.265L378.181 203.344L370.795 193.771L370.149 192.936L363.428 184.217L362.845 183.458L356.698 175.479L356.152 174.777L350.506 167.462L350.014 166.817L344.805 160.061L344.35 159.473L339.541 153.23L339.113 152.68L334.66 146.902L334.259 146.38L330.116 141.01L329.752 140.536L325.881 135.517L325.535 135.071L321.929 130.384L321.61 129.976L318.223 125.583L317.922 125.194L314.753 121.077L314.471 120.716L311.484 116.845L311.22 116.494L308.406 112.851L308.151 112.528L305.501 109.084L305.264 108.78L302.76 105.526L302.532 105.242L300.164 102.158L299.946 101.883L297.696 98.9607L297.496 98.7046L295.356 95.9342L295.165 95.6875L293.143 93.0499L292.961 92.8127L291.021 90.308L290.848 90.0803L289.008 87.6988L288.845 87.4806L287.087 85.2036L286.932 84.9949L285.247 82.8222L285.102 82.6229L283.499 80.5451L283.353 80.3554L281.814 78.363L281.678 78.1922L280.202 76.2757L280.075 76.1049L278.663 74.2833L278.536 74.1125L277.188 72.3572L277.06 72.2055L275.767 70.5167L275.649 70.3649L274.401 68.7424L274.283 68.6001L273.081 67.0442L272.981 66.9018L271.824 65.4028L271.715 65.27L270.604 63.8183L270.504 63.695L269.429 62.3003L269.329 62.177L268.291 60.8297L268.2 60.7064L267.198 59.4161L267.116 59.2927L266.142 58.0403L266.06 57.9265L265.122 56.7216L265.04 56.6077L264.138 55.4407L264.102 55.3838Z'
                      fill='#1C1C1C'
                      fill-opacity='0.6'
                    />
                    <path
                      d='M287.415 55.3838H286.823L286.877 55.4407L288.125 56.6077L288.243 56.7216L289.546 57.9265L289.664 58.0403L291.003 59.2927L291.13 59.4161L292.514 60.7064L292.642 60.8297L294.081 62.177L294.217 62.3003L295.711 63.695L295.847 63.8183L297.396 65.27L297.532 65.4028L299.144 66.9018L299.29 67.0442L300.956 68.6001L301.111 68.7424L302.85 70.3649L303.014 70.5167L304.817 72.2055L304.981 72.3572L306.857 74.1125L307.04 74.2833L308.988 76.1049L309.18 76.2757L311.219 78.1922L311.411 78.363L313.542 80.3554L313.742 80.5451L315.964 82.6229L316.174 82.8222L318.505 84.9949L318.723 85.2036L321.164 87.4806L321.392 87.6988L323.951 90.0803L324.187 90.308L326.874 92.8127L327.12 93.0499L329.943 95.6875L330.207 95.9342L333.166 98.7046L333.449 98.9607L336.572 101.883L336.864 102.158L340.16 105.242L340.47 105.526L343.949 108.78L344.277 109.084L347.965 112.528L348.311 112.851L352.209 116.494L352.582 116.845L356.725 120.716L357.117 121.077L361.516 125.194L361.935 125.583L366.633 129.976L367.071 130.384L372.088 135.071L372.562 135.517L377.926 140.536L378.436 141.01L384.191 146.38L384.738 146.902L390.93 152.68L391.513 153.23L398.197 159.473L398.826 160.061L406.056 166.817L406.739 167.462L414.571 174.777L415.327 175.479L423.86 183.458L424.67 184.217L434.005 192.936L434.897 193.771L445.133 203.344L446.116 204.265L457.4 214.805L458.502 215.83L471.005 227.519L471.615 228.088H473.555L472.945 227.519L460.35 215.83L459.239 214.805L447.874 204.265L446.891 203.344L436.573 193.771L435.671 192.936L426.273 184.217L425.454 183.458L416.857 175.479L416.101 174.777L408.215 167.462L407.513 166.817L400.237 160.061L399.6 159.473L392.879 153.23L392.278 152.68L386.049 146.902L385.493 146.38L379.702 141.01L379.192 140.536L373.782 135.517L373.309 135.071L368.254 130.384L367.808 129.976L363.073 125.583L362.654 125.194L358.219 121.077L357.827 120.716L353.656 116.845L353.283 116.494L349.349 112.851L349.003 112.528L345.297 109.084L344.96 108.78L341.454 105.526L341.144 105.242L337.829 102.158L337.529 101.883L334.387 98.9607L334.104 98.7046L331.117 95.9342L330.844 95.6875L328.012 93.0499L327.757 92.8127L325.053 90.308L324.816 90.0803L322.238 87.6988L322.002 87.4806L319.552 85.2036L319.324 84.9949L316.984 82.8222L316.774 82.6229L314.534 80.5451L314.325 80.3554L312.185 78.363L311.993 78.1922L309.935 76.2757L309.744 76.1049L307.777 74.2833L307.604 74.1125L305.71 72.3572L305.537 72.2055L303.725 70.5167L303.561 70.3649L301.812 68.7424L301.657 68.6001L299.973 67.0442L299.827 66.9018L298.206 65.4028L298.06 65.27L296.503 63.8183L296.367 63.695L294.864 62.3003L294.727 62.177L293.279 60.8297L293.152 60.7064L291.749 59.4161L291.631 59.2927L290.274 58.0403L290.156 57.9265L288.854 56.7216L288.735 56.6077L287.469 55.4407L287.415 55.3838Z'
                      fill='#1C1C1C'
                      fill-opacity='0.6'
                    />
                    <path
                      d='M310.736 55.3838H310.145L310.217 55.4407L311.829 56.6077L311.975 56.7216L313.641 57.9265L313.796 58.0403L315.526 59.2927L315.681 59.4161L317.466 60.7064L317.639 60.8297L319.488 62.177L319.661 62.3003L321.573 63.695L321.756 63.8183L323.75 65.27L323.932 65.4028L325.999 66.9018L326.19 67.0442L328.331 68.6001L328.531 68.7424L330.762 70.3649L330.971 70.5167L333.294 72.2055L333.512 72.3572L335.935 74.1125L336.153 74.2833L338.676 76.1049L338.912 76.2757L341.535 78.1922L341.781 78.363L344.522 80.3554L344.777 80.5451L347.646 82.6229L347.919 82.8222L350.915 84.9949L351.188 85.2036L354.33 87.4806L354.621 87.6988L357.918 90.0803L358.228 90.308L361.679 92.8127L361.998 93.0499L365.631 95.6875L365.968 95.9342L369.784 98.7046L370.139 98.9607L374.164 101.883L374.538 102.158L378.781 105.242L379.182 105.526L383.654 108.78L384.082 109.084L388.817 112.528L389.263 112.851L394.29 116.494L394.764 116.845L400.091 120.716L400.592 121.077L406.265 125.194L406.794 125.583L412.84 129.976L413.414 130.384L419.862 135.071L420.472 135.517L427.384 140.536L428.03 141.01L435.434 146.38L436.144 146.902L444.104 152.68L444.869 153.23L453.456 159.473L454.276 160.061L463.565 166.817L464.457 167.462L474.529 174.777L475.503 175.479L486.477 183.458L487.533 184.217L499.536 192.936L500.683 193.771L513.861 203.344L515.126 204.265L529.652 214.805L531.063 215.83L547.146 227.519L547.929 228.088H549.878L549.085 227.519L532.903 215.83L531.482 214.805L516.884 204.265L515.609 203.344L502.359 193.771L501.202 192.936L489.127 184.217L488.071 183.458L477.033 175.479L476.059 174.777L465.923 167.462L465.031 166.817L455.687 160.061L454.868 159.473L446.225 153.23L445.46 152.68L437.456 146.902L436.745 146.38L429.296 141.01L428.64 140.536L421.692 135.517L421.082 135.071L414.589 130.384L414.015 129.976L407.941 125.583L407.404 125.194L401.703 121.077L401.193 120.716L395.838 116.845L395.356 116.494L390.31 112.851L389.855 112.528L385.092 109.084L384.664 108.78L380.166 105.526L379.765 105.242L375.503 102.158L375.121 101.883L371.077 98.9607L370.713 98.7046L366.879 95.9342L366.533 95.6875L362.89 93.0499L362.562 92.8127L359.093 90.308L358.783 90.0803L355.468 87.6988L355.177 87.4806L352.017 85.2036L351.735 84.9949L348.72 82.8222L348.456 82.6229L345.569 80.5451L345.314 80.3554L342.555 78.363L342.309 78.1922L339.668 76.2757L339.431 76.1049L336.9 74.2833L336.672 74.1125L334.241 72.3572L334.022 72.2055L331.691 70.5167L331.481 70.3649L329.232 68.7424L329.032 68.6001L326.873 67.0442L326.682 66.9018L324.606 65.4028L324.415 65.27L322.411 63.8183L322.238 63.695L320.307 62.3003L320.135 62.177L318.277 60.8297L318.104 60.7064L316.31 59.4161L316.146 59.2927L314.416 58.0403L314.261 57.9265L312.585 56.7216L312.43 56.6077L310.809 55.4407L310.736 55.3838Z'
                      fill='#1C1C1C'
                      fill-opacity='0.6'
                    />
                    <path
                      d='M334.049 55.3838H333.457L333.548 55.4407L335.515 56.6077L335.697 56.7216L337.737 57.9265L337.929 58.0403L340.041 59.2927L340.232 59.4161L342.418 60.7064L342.618 60.8297L344.886 62.177L345.095 62.3003L347.445 63.695L347.664 63.8183L350.095 65.27L350.323 65.4028L352.845 66.9018L353.082 67.0442L355.705 68.6001L355.951 68.7424L358.673 70.3649L358.928 70.5167L361.77 72.2055L362.034 72.3572L364.994 74.1125L365.267 74.2833L368.345 76.1049L368.636 76.2757L371.851 78.1922L372.151 78.363L375.503 80.3554L375.812 80.5451L379.318 82.6229L379.646 82.8222L383.316 84.9949L383.653 85.2036L387.496 87.4806L387.851 87.6988L391.876 90.0803L392.259 90.308L396.475 92.8127L396.876 93.0499L401.311 95.6875L401.721 95.9342L406.392 98.7046L406.83 98.9607L411.747 101.883L412.202 102.158L417.393 105.242L417.876 105.526L423.358 108.78L423.868 109.084L429.669 112.528L430.215 112.851L436.353 116.494L436.936 116.845L443.447 120.716L444.067 121.077L450.997 125.194L451.653 125.583L459.038 129.976L459.739 130.384L467.626 135.071L468.372 135.517L476.823 140.536L477.616 141.01L486.668 146.38L487.542 146.902L497.277 152.68L498.197 153.23L508.706 159.473L509.708 160.061L521.073 166.817L522.156 167.462L534.478 174.777L535.671 175.479L549.085 183.458L550.369 184.217L565.049 192.936L566.46 193.771L582.57 203.344L584.118 204.265L601.876 214.805L603.597 215.83L623.277 227.519L624.233 228.088H626.173L625.217 227.519L605.446 215.83L603.716 214.805L585.876 204.265L584.318 203.344L568.136 193.771L566.724 192.936L551.972 184.217L550.678 183.458L537.201 175.479L536.008 174.777L523.623 167.462L522.539 166.817L511.119 160.061L510.117 159.473L499.554 153.23L498.625 152.68L488.844 146.902L487.979 146.38L478.881 141.01L478.08 140.536L469.593 135.517L468.846 135.071L460.914 130.384L460.213 129.976L452.791 125.583L452.135 125.194L445.178 121.077L444.558 120.716L438.002 116.845L437.428 116.494L431.254 112.851L430.707 112.528L424.879 109.084L424.369 108.78L418.869 105.526L418.377 105.242L413.168 102.158L412.703 101.883L407.768 98.9607L407.321 98.7046L402.631 95.9342L402.212 95.6875L397.759 93.0499L397.368 92.8127L393.124 90.308L392.742 90.0803L388.698 87.6988L388.343 87.4806L384.482 85.2036L384.136 84.9949L380.457 82.8222L380.129 82.6229L376.605 80.5451L376.295 80.3554L372.925 78.363L372.616 78.1922L369.392 76.2757L369.101 76.1049L366.013 74.2833L365.731 74.1125L362.762 72.3572L362.498 72.2055L359.648 70.5167L359.393 70.3649L356.652 68.7424L356.406 68.6001L353.765 67.0442L353.528 66.9018L350.997 65.4028L350.76 65.27L348.319 63.8183L348.101 63.695L345.742 62.3003L345.533 62.177L343.256 60.8297L343.056 60.7064L340.861 59.4161L340.661 59.2927L338.548 58.0403L338.357 57.9265L336.308 56.7216L336.125 56.6077L334.14 55.4407L334.049 55.3838Z'
                      fill='#1C1C1C'
                      fill-opacity='0.6'
                    />
                    <path
                      d='M357.371 55.3838H356.779L356.889 55.4407L359.211 56.6077L359.429 56.7216L361.843 57.9265L362.07 58.0403L364.556 59.2927L364.793 59.4161L367.37 60.7064L367.616 60.8297L370.284 62.177L370.539 62.3003L373.308 63.695L373.572 63.8183L376.45 65.27L376.714 65.4028L379.701 66.9018L379.983 67.0442L383.079 68.6001L383.371 68.7424L386.595 70.3649L386.895 70.5167L390.255 72.2055L390.565 72.3572L394.062 74.1125L394.39 74.2833L398.023 76.1049L398.369 76.2757L402.167 78.1922L402.522 78.363L406.483 80.3554L406.857 80.5451L411 82.6229L411.392 82.8222L415.718 84.9949L416.127 85.2036L420.663 87.4806L421.091 87.6988L425.844 90.0803L426.29 90.308L431.29 92.8127L431.754 93.0499L436.991 95.6875L437.492 95.9342L443.001 98.7046L443.52 98.9607L449.339 101.883L449.886 102.158L456.015 105.242L456.588 105.526L463.063 108.78L463.673 109.084L470.522 112.528L471.168 112.851L478.426 116.494L479.109 116.845L486.823 120.716L487.551 121.077L495.738 125.194L496.512 125.583L505.254 129.976L506.074 130.384L515.408 135.071L516.292 135.517L526.273 140.536L527.22 141.01L537.92 146.38L538.94 146.902L550.451 152.68L551.544 153.23L563.965 159.473L565.149 160.061L578.59 166.817L579.874 167.462L594.436 174.777L595.848 175.479L611.711 183.458L613.232 184.217L630.58 192.936L632.247 193.771L651.298 203.344L653.128 204.265L674.119 214.805L676.159 215.83L699.418 227.519L700.547 228.088H702.496L701.357 227.519L678.008 215.83L675.959 214.805L654.886 204.265L653.046 203.344L633.922 193.771L632.256 192.936L614.826 184.217L613.305 183.458L597.377 175.479L595.966 174.777L581.341 167.462L580.057 166.817L566.56 160.061L565.377 159.473L552.91 153.23L551.808 152.68L540.251 146.902L539.222 146.38L528.476 141.01L527.529 140.536L517.512 135.517L516.62 135.071L507.258 130.384L506.429 129.976L497.659 125.583L496.876 125.194L488.653 121.077L487.924 120.716L480.184 116.845L479.501 116.494L472.206 112.851L471.56 112.528L464.684 109.084L464.074 108.78L457.572 105.526L456.998 105.242L450.842 102.158L450.296 101.883L444.458 98.9607L443.939 98.7046L438.402 95.9342L437.901 95.6875L432.638 93.0499L432.173 92.8127L427.156 90.308L426.709 90.0803L421.938 87.6988L421.509 87.4806L416.956 85.2036L416.546 84.9949L412.193 82.8222L411.811 82.6229L407.649 80.5451L407.276 80.3554L403.296 78.363L402.941 78.1922L399.125 76.2757L398.779 76.1049L395.127 74.2833L394.8 74.1125L391.294 72.3572L390.975 72.2055L387.605 70.5167L387.305 70.3649L384.072 68.7424L383.781 68.6001L380.666 67.0442L380.384 66.9018L377.388 65.4028L377.114 65.27L374.228 63.8183L373.973 63.695L371.186 62.3003L370.931 62.177L368.254 60.8297L368.008 60.7064L365.422 59.4161L365.185 59.2927L362.68 58.0403L362.453 57.9265L360.039 56.7216L359.821 56.6077L357.481 55.4407L357.371 55.3838Z'
                      fill='#1C1C1C'
                      fill-opacity='0.6'
                    />
                    <path
                      d='M380.694 55.3838H380.093L380.22 55.4407L382.907 56.6077L383.162 56.7216L385.939 57.9265L386.194 58.0403L389.072 59.2927L389.345 59.4161L392.323 60.7064L392.605 60.8297L395.683 62.177L395.975 62.3003L399.171 63.695L399.472 63.8183L402.796 65.27L403.105 65.4028L406.548 66.9018L406.876 67.0442L410.454 68.6001L410.782 68.7424L414.507 70.3649L414.853 70.5167L418.732 72.2055L419.088 72.3572L423.122 74.1125L423.504 74.2833L427.702 76.1049L428.094 76.2757L432.474 78.1922L432.884 78.363L437.465 80.3554L437.893 80.5451L442.674 82.6229L443.12 82.8222L448.12 84.9949L448.593 85.2036L453.829 87.4806L454.321 87.6988L459.813 90.0803L460.322 90.308L466.087 92.8127L466.624 93.0499L472.671 95.6875L473.245 95.9342L479.61 98.7046L480.212 98.9607L486.914 101.883L487.551 102.158L494.627 105.242L495.292 105.526L502.76 108.78L503.461 109.084L511.365 112.528L512.112 112.851L520.49 116.494L521.283 116.845L530.18 120.716L531.018 121.077L540.47 125.194L541.372 125.583L551.453 129.976L552.4 130.384L563.173 135.071L564.193 135.517L575.713 140.536L576.806 141.01L589.155 146.38L590.338 146.902L603.616 152.68L604.882 153.23L619.216 159.473L620.582 160.061L636.09 166.817L637.575 167.462L654.386 174.777L656.007 175.479L674.32 183.458L676.069 184.217L696.103 192.936L698.025 193.771L720.008 203.344L722.121 204.265L746.345 214.805L748.703 215.83L775.55 227.519L776.852 228.088H778.792L777.49 227.519L750.552 215.83L748.184 214.805L723.879 204.265L721.757 203.344L699.7 193.771L697.77 192.936L677.671 184.217L675.914 183.458L657.536 175.479L655.915 174.777L639.041 167.462L637.556 166.817L621.993 160.061L620.627 159.473L606.239 153.23L604.973 152.68L591.65 146.902L590.457 146.38L578.063 141.01L576.97 140.536L565.413 135.517L564.384 135.071L553.584 130.384L552.628 129.976L542.51 125.583L541.618 125.194L532.129 121.077L531.282 120.716L522.357 116.845L521.565 116.494L513.159 112.851L512.413 112.528L504.472 109.084L503.77 108.78L496.276 105.526L495.611 105.242L488.508 102.158L487.879 101.883L481.14 98.9607L480.548 98.7046L474.156 95.9342L473.582 95.6875L467.517 93.0499L466.97 92.8127L461.188 90.308L460.678 90.0803L455.168 87.6988L454.676 87.4806L449.413 85.2036L448.948 84.9949L443.93 82.8222L443.484 82.6229L438.685 80.5451L438.257 80.3554L433.658 78.363L433.248 78.1922L428.85 76.2757L428.458 76.1049L424.242 74.2833L423.869 74.1125L419.816 72.3572L419.452 72.2055L415.572 70.5167L415.217 70.3649L411.483 68.7424L411.146 68.6001L407.559 67.0442L407.24 66.9018L403.779 65.4028L403.47 65.27L400.137 63.8183L399.836 63.695L396.621 62.3003L396.33 62.177L393.243 60.8297L392.96 60.7064L389.973 59.4161L389.7 59.2927L386.813 58.0403L386.549 57.9265L383.763 56.7216L383.508 56.6077L380.812 55.4407L380.694 55.3838Z'
                      fill='#1C1C1C'
                      fill-opacity='0.6'
                    />
                  </g>
                  <g
                    style={{
                      mixBlendMode: "overlay",
                    }}
                  >
                    <path
                      d='M-136.006 55.0137H546.994'
                      stroke='#6e6eff'
                      stroke-width='0.450231'
                      stroke-miterlimit='10'
                    />
                  </g>
                  <path
                    style={{ mixBlendMode: "screen" }}
                    d='M205.495 64.0269C634.039 64.0269 981.442 54.8578 981.442 43.5472C981.442 32.2365 634.039 23.0674 205.495 23.0674C-223.048 23.0674 -570.451 32.2365 -570.451 43.5472C-570.451 54.8578 -223.048 64.0269 205.495 64.0269Z'
                    fill='url(#paint1_radial_269_2519)'
                  />
                  <path
                    style={{ mixBlendMode: "screen" }}
                    opacity='0.5'
                    d='M196.522 115.646C486.344 115.646 721.29 89.758 721.29 57.8231C721.29 25.8883 486.344 0 196.522 0C-93.2993 0 -328.246 25.8883 -328.246 57.8231C-328.246 89.758 -93.2993 115.646 196.522 115.646Z'
                    fill='url(#paint2_radial_269_2519)'
                  />
                </g>
                <path
                  d='M300.274 108.337H344.846L315.356 81.2524H348.448'
                  stroke='url(#paint3_linear_269_2519)'
                  stroke-width='0.900461'
                  className='wire'
                />
                <path
                  d='M58.9496 159.058H14.3768L39.5897 133.451H-7.23427'
                  stroke='url(#paint4_linear_269_2519)'
                  stroke-width='0.900461'
                  className='wire'
                />
              </g>
              <defs>
                <radialGradient
                  id='paint0_radial_269_2519'
                  cx='0'
                  cy='0'
                  r='1'
                  gradientUnits='userSpaceOnUse'
                  gradientTransform='translate(199.247 121.257) rotate(-180) scale(463.402 128.077)'
                >
                  <stop offset='0.01' stop-color='#651FFF' />
                  <stop offset='1' stop-opacity='0' />
                </radialGradient>
                <radialGradient
                  id='paint1_radial_269_2519'
                  cx='0'
                  cy='0'
                  r='1'
                  gradientUnits='userSpaceOnUse'
                  gradientTransform='translate(209.204 53.8625) scale(776.46 21.3442)'
                >
                  <stop stop-color='white' />
                  <stop offset='0.23' stop-color='#651FFF' />
                  <stop offset='1' stop-opacity='0' />
                </radialGradient>
                <radialGradient
                  id='paint2_radial_269_2519'
                  cx='0'
                  cy='0'
                  r='1'
                  gradientUnits='userSpaceOnUse'
                  gradientTransform='translate(191.82 57.8232) scale(524.261 57.6166)'
                >
                  <stop stop-color='white' />
                  <stop offset='0.23' stop-color='#651FFF' />
                  <stop offset='1' stop-opacity='0' />
                </radialGradient>
                <linearGradient
                  id='paint3_linear_269_2519'
                  x1='321.166'
                  y1='138.148'
                  x2='357.327'
                  y2='137.874'
                  gradientUnits='userSpaceOnUse'
                >
                  <stop stop-color='#7673FF' stop-opacity='0' />
                  <stop offset='0.654778' stop-color='#7673FF' />
                  <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                </linearGradient>
                <linearGradient
                  id='paint4_linear_269_2519'
                  x1='38.0575'
                  y1='188.87'
                  x2='1.89629'
                  y2='188.595'
                  gradientUnits='userSpaceOnUse'
                >
                  <stop stop-color='#7673FF' stop-opacity='0' />
                  <stop offset='0.654778' stop-color='#7673FF' />
                  <stop offset='1' stop-color='#7673FF' stop-opacity='0' />
                </linearGradient>
                <clipPath id='clip0_269_2519'>
                  <rect
                    width='683'
                    height='228'
                    fill='white'
                    transform='translate(-136)'
                  />
                </clipPath>
              </defs>
            </svg>
          )}
        </div>
        <Footer />
      </div>
    </section>
  );
};
